/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class ServiceRouteServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    listRoutes(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListRoutes(_response);
        });
    }

    protected processListRoutes(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class ListRoutesServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    1(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    2(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process2(_response);
        });
    }

    protected process2(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    3(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process3(_response);
        });
    }

    protected process3(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    5(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process5(_response);
        });
    }

    protected process5(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    6(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process6(_response);
        });
    }

    protected process6(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    4(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process4(_response);
        });
    }

    protected process4(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class StockInOrderServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 完成入库单
     * @param ids (optional) 入库单ids
     * @return OK
     */
    finishInOrder(ids: string[] | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFinishInOrder(_response);
        });
    }

    protected processFinishInOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 关闭入库单
     * @param ids (optional) 入库单ids
     * @return OK
     */
    closeInOrder(ids: string[] | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order/closing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCloseInOrder(_response);
        });
    }

    protected processCloseInOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 新增入库单
     * @param stockInOrderAddDTO stockInOrderAddDTO
     * @return OK
     */
    createStockInOrder(stockInOrderAddDTO: StockInOrderAddDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order/create-stock-in-order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockInOrderAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateStockInOrder(_response);
        });
    }

    protected processCreateStockInOrder(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 删除入库单
     * @param ids id
     * @return OK
     */
    deleteStockInOrder(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order/delete-stock-in-order?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteStockInOrder(_response);
        });
    }

    protected processDeleteStockInOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询入库单
     * @param id id
     * @return OK
     */
    getStockInOrder(id: string): Promise<StockInOrderVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order/get-stock-in-order?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockInOrder(_response);
        });
    }

    protected processGetStockInOrder(response: AxiosResponse): Promise<StockInOrderVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? StockInOrderVo.fromJS(resultData200) : new StockInOrderVo();
            return result200;
        }
        return Promise.resolve<StockInOrderVo>(<any>null);
    }

    /**
     * 通过入库单号查询入库单
     * @param code code
     * @return OK
     */
    getStockInOrderByCode(code: string): Promise<StockInOrderVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order/get-stock-in-order-by-code?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockInOrderByCode(_response);
        });
    }

    protected processGetStockInOrderByCode(response: AxiosResponse): Promise<StockInOrderVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? StockInOrderVo.fromJS(resultData200) : new StockInOrderVo();
            return result200;
        }
        return Promise.resolve<StockInOrderVo>(<any>null);
    }

    /**
     * 查询分页
     * @param areaId 库区Id
     * @param current (optional) 当前页
     * @param filterPlus 是否高级筛选
     * @param keyWord (optional) 关键词
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageStockInOrder(areaId: string, current: number | null | undefined, filterPlus: boolean, keyWord: string | null | undefined, size: number | null | undefined): Promise<IPageOfStockInOrderVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order/page?";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined and cannot be null.");
        else
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (filterPlus === undefined || filterPlus === null)
            throw new Error("The parameter 'filterPlus' must be defined and cannot be null.");
        else
            url_ += "filterPlus=" + encodeURIComponent("" + filterPlus) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageStockInOrder(_response);
        });
    }

    protected processGetPageStockInOrder(response: AxiosResponse): Promise<IPageOfStockInOrderVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfStockInOrderVo.fromJS(resultData200) : new IPageOfStockInOrderVo();
            return result200;
        }
        return Promise.resolve<IPageOfStockInOrderVo>(<any>null);
    }

    /**
     * 库存统计中分页查询入库单记录
     * @param areaId 库区id
     * @param locationId 库区id
     * @param materialId 物料id
     * @param query_current (optional) 当前页
     * @param query_size (optional) 每页的数量
     * @return OK
     */
    getInOrderRecord(areaId: string, locationId: string, materialId: string, query_current: number | null | undefined, query_size: number | null | undefined): Promise<IPageOfInOrderRecordVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order/record/page?";
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined and cannot be null.");
        else
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined and cannot be null.");
        else
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&"; 
        if (materialId === undefined || materialId === null)
            throw new Error("The parameter 'materialId' must be defined and cannot be null.");
        else
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&"; 
        if (query_current !== undefined)
            url_ += "query.current=" + encodeURIComponent("" + query_current) + "&"; 
        if (query_size !== undefined)
            url_ += "query.size=" + encodeURIComponent("" + query_size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetInOrderRecord(_response);
        });
    }

    protected processGetInOrderRecord(response: AxiosResponse): Promise<IPageOfInOrderRecordVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfInOrderRecordVO.fromJS(resultData200) : new IPageOfInOrderRecordVO();
            return result200;
        }
        return Promise.resolve<IPageOfInOrderRecordVO>(<any>null);
    }

    /**
     * 重启入库单
     * @param ids (optional) 入库单ids
     * @return OK
     */
    restartInOrder(ids: string[] | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order/restarting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRestartInOrder(_response);
        });
    }

    protected processRestartInOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class StockInOrderMaterialServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 批量是否入库
     * @param dto (optional) 入库单物料id
     * @return OK
     */
    putInStorage(dto: WarehousingDTO | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order-material";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPutInStorage(_response);
        });
    }

    protected processPutInStorage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 添加入库单物料
     * @param stockInOrderMaterialAddDTO stockInOrderMaterialAddDTO
     * @return OK
     */
    createStockInOrderMaterial(stockInOrderMaterialAddDTO: StockInOrderMaterialAddDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order-material/create-stock-in-order-material";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockInOrderMaterialAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateStockInOrderMaterial(_response);
        });
    }

    protected processCreateStockInOrderMaterial(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除入库单物料
     * @param id id
     * @return OK
     */
    deleteStockInOrderMaterial(id: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order-material/delete-stock-in-order-material?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteStockInOrderMaterial(_response);
        });
    }

    protected processDeleteStockInOrderMaterial(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 编辑入库单物料
     * @param stockInOrderMaterialUpdateDTO stockInOrderMaterialUpdateDTO
     * @return OK
     */
    editStockInOrderMaterial(stockInOrderMaterialUpdateDTO: StockInOrderMaterialUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order-material/edit-stock-in-order-material";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockInOrderMaterialUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditStockInOrderMaterial(_response);
        });
    }

    protected processEditStockInOrderMaterial(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询入库单物料
     * @param id id
     * @return OK
     */
    getStockInOrderMaterial(id: string): Promise<StockInOrderMaterialVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order-material/get-stock-in-order-material?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockInOrderMaterial(_response);
        });
    }

    protected processGetStockInOrderMaterial(response: AxiosResponse): Promise<StockInOrderMaterialVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? StockInOrderMaterialVo.fromJS(resultData200) : new StockInOrderMaterialVo();
            return result200;
        }
        return Promise.resolve<StockInOrderMaterialVo>(<any>null);
    }

    /**
     * 查询入库单物料列表
     * @param orderId 入库单Id
     * @return OK
     */
    getStockInOrderMaterialList(orderId: string): Promise<StockInOrderMaterialVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order-material/list?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined and cannot be null.");
        else
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockInOrderMaterialList(_response);
        });
    }

    protected processGetStockInOrderMaterialList(response: AxiosResponse): Promise<StockInOrderMaterialVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockInOrderMaterialVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StockInOrderMaterialVo[]>(<any>null);
    }

    /**
     * 查询分页
     * @param current (optional) 当前页
     * @param orderId (optional) 入库单ID
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageStockInOrderMaterial(current: number | null | undefined, orderId: string | null | undefined, size: number | null | undefined): Promise<IPageOfStockInOrderMaterialVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order-material/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageStockInOrderMaterial(_response);
        });
    }

    protected processGetPageStockInOrderMaterial(response: AxiosResponse): Promise<IPageOfStockInOrderMaterialVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfStockInOrderMaterialVo.fromJS(resultData200) : new IPageOfStockInOrderMaterialVo();
            return result200;
        }
        return Promise.resolve<IPageOfStockInOrderMaterialVo>(<any>null);
    }

    /**
     * 检验入库单物料
     * @param testMaterialDTO testMaterialDTO
     * @return OK
     */
    testMaterial(testMaterialDTO: TestMaterialDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-order-material/test-material";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(testMaterialDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processTestMaterial(_response);
        });
    }

    protected processTestMaterial(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class StockInOutRecordExcelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出出入库记录
     * @param areaId (optional) areaId
     * @param locationId (optional) locationId
     * @param materialId (optional) materialId
     * @return OK
     */
    exportInOutOrder(areaId: string | null | undefined, locationId: string | null | undefined, materialId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-out-record/excels/export?";
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&"; 
        if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportInOutOrder(_response);
        });
    }

    protected processExportInOutOrder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class StockInTypeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增入库类型
     * @param stockInTypeAddDTO stockInTypeAddDTO
     * @return OK
     */
    createStockInType(stockInTypeAddDTO: StockInTypeAddDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-type/create-stock-in-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockInTypeAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateStockInType(_response);
        });
    }

    protected processCreateStockInType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除入库类型（支持批量）
     * @param ids id
     * @return OK
     */
    deleteStockInType(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-type/delete-stock-in-type?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteStockInType(_response);
        });
    }

    protected processDeleteStockInType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询入库类型
     * @param id id
     * @return OK
     */
    getStockInType(id: string): Promise<StockInTypeVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-type/get-stock-in-type?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockInType(_response);
        });
    }

    protected processGetStockInType(response: AxiosResponse): Promise<StockInTypeVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? StockInTypeVo.fromJS(resultData200) : new StockInTypeVo();
            return result200;
        }
        return Promise.resolve<StockInTypeVo>(<any>null);
    }

    /**
     * 查询入库类型列表（不分页）
     * @return OK
     */
    getStockInTypeList(): Promise<StockInTypeVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-type/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockInTypeList(_response);
        });
    }

    protected processGetStockInTypeList(response: AxiosResponse): Promise<StockInTypeVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockInTypeVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StockInTypeVo[]>(<any>null);
    }

    /**
     * OpenApi新增入库类型
     * @param stockInTypeAddDTO stockInTypeAddDTO
     * @return OK
     */
    createStockInTypeForOpenApi(stockInTypeAddDTO: StockInTypeAddOpenApiDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-type/open-api/create-stock-in-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockInTypeAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateStockInTypeForOpenApi(_response);
        });
    }

    protected processCreateStockInTypeForOpenApi(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * OpenApi修改入库类型
     * @param stockInTypeUpdateDTO stockInTypeUpdateDTO
     * @return OK
     */
    updateStockInTypeForOpenApi(stockInTypeUpdateDTO: StockInTypeUpdateOpenApiDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-type/open-api/update-stock-in-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockInTypeUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateStockInTypeForOpenApi(_response);
        });
    }

    protected processUpdateStockInTypeForOpenApi(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询分页
     * @param current (optional) 当前页
     * @param keyWord (optional) keyWord
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageStockInType(current: number | null | undefined, keyWord: string | null | undefined, size: number | null | undefined): Promise<IPageOfStockInTypeVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-type/page?";
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageStockInType(_response);
        });
    }

    protected processGetPageStockInType(response: AxiosResponse): Promise<IPageOfStockInTypeVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfStockInTypeVo.fromJS(resultData200) : new IPageOfStockInTypeVo();
            return result200;
        }
        return Promise.resolve<IPageOfStockInTypeVo>(<any>null);
    }

    /**
     * 修改入库类型
     * @param stockInTypeUpdateDTO stockInTypeUpdateDTO
     * @return OK
     */
    updateStockInType(stockInTypeUpdateDTO: StockInTypeUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-in-type/update-stock-in-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockInTypeUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateStockInType(_response);
        });
    }

    protected processUpdateStockInType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class StockOutOrderMaterialServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 通过出库单Code获得出库单物料列表
     * @param outOrderCode (optional) 出库单号
     * @return OK
     */
    getStockOutOrderMaterialByCode(outOrderCode: string | null | undefined): Promise<OutMaterialsVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-order-materials/get-stock-out-order-material-by-code?";
        if (outOrderCode !== undefined)
            url_ += "outOrderCode=" + encodeURIComponent("" + outOrderCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockOutOrderMaterialByCode(_response);
        });
    }

    protected processGetStockOutOrderMaterialByCode(response: AxiosResponse): Promise<OutMaterialsVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutMaterialsVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<OutMaterialsVO[]>(<any>null);
    }

    /**
     * 根据维修/保养的id和code，查询已经出库的备品备件
     * @param tpmCode tpmCode
     * @param tpmId tpmId
     * @return OK
     */
    getStockOutOrderMaterialListByTpmCodeAndTpmId(tpmCode: string, tpmId: string): Promise<StockOutOrderMaterialTpmVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-order-materials/get-stock-out-order-material-by-tpm?";
        if (tpmCode === undefined || tpmCode === null)
            throw new Error("The parameter 'tpmCode' must be defined and cannot be null.");
        else
            url_ += "tpmCode=" + encodeURIComponent("" + tpmCode) + "&"; 
        if (tpmId === undefined || tpmId === null)
            throw new Error("The parameter 'tpmId' must be defined and cannot be null.");
        else
            url_ += "tpmId=" + encodeURIComponent("" + tpmId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockOutOrderMaterialListByTpmCodeAndTpmId(_response);
        });
    }

    protected processGetStockOutOrderMaterialListByTpmCodeAndTpmId(response: AxiosResponse): Promise<StockOutOrderMaterialTpmVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockOutOrderMaterialTpmVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StockOutOrderMaterialTpmVO[]>(<any>null);
    }

    /**
     * 查询出库单物料列表
     * @param id 出库单id
     * @return OK
     */
    listStockOutOrderMaterial(id: string): Promise<StockOutOrderMaterialVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-order-materials/list/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListStockOutOrderMaterial(_response);
        });
    }

    protected processListStockOutOrderMaterial(response: AxiosResponse): Promise<StockOutOrderMaterialVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockOutOrderMaterialVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StockOutOrderMaterialVO[]>(<any>null);
    }
}

export class StockOutOrderServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新建出库单
     * @param dto dto
     * @return OK
     */
    createOutOrder(dto: StockOutOrderSubmitDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateOutOrder(_response);
        });
    }

    protected processCreateOutOrder(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 根据计划单号查出库单
     * @param planId (optional) 计划id
     * @return OK
     */
    getOutOrderByPlanId(planId: string | null | undefined): Promise<OutOrderPlanVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-orders/get-out-order?";
        if (planId !== undefined)
            url_ += "planId=" + encodeURIComponent("" + planId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOutOrderByPlanId(_response);
        });
    }

    protected processGetOutOrderByPlanId(response: AxiosResponse): Promise<OutOrderPlanVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutOrderPlanVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<OutOrderPlanVO[]>(<any>null);
    }

    /**
     * 根据出库计划单号查出库单
     * @param stockOutPlanId (optional) 出库计划计划id
     * @return OK
     */
    getOutOrderByStockOutPlanId(stockOutPlanId: string | null | undefined): Promise<OutOrderPlanVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-orders/get-out-order-by-stock-out-plan?";
        if (stockOutPlanId !== undefined)
            url_ += "stockOutPlanId=" + encodeURIComponent("" + stockOutPlanId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOutOrderByStockOutPlanId(_response);
        });
    }

    protected processGetOutOrderByStockOutPlanId(response: AxiosResponse): Promise<OutOrderPlanVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutOrderPlanVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<OutOrderPlanVO[]>(<any>null);
    }

    /**
     * 通过出库单号查询出库单
     * @param code code
     * @return OK
     */
    getStockOutOrderByCode(code: string): Promise<StockOutOrderVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-orders/get-stock-out-order-by-code?";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockOutOrderByCode(_response);
        });
    }

    protected processGetStockOutOrderByCode(response: AxiosResponse): Promise<StockOutOrderVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? StockOutOrderVO.fromJS(resultData200) : new StockOutOrderVO();
            return result200;
        }
        return Promise.resolve<StockOutOrderVO>(<any>null);
    }

    /**
     * 分页查询出库单
     * @param areaId (optional) areaId
     * @param current (optional) 当前页
     * @param keyWord (optional) keyWord
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageStockOutOrder(areaId: string | null | undefined, current: number | null | undefined, keyWord: string | null | undefined, size: number | null | undefined): Promise<IPageOfStockOutOrderVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-orders/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageStockOutOrder(_response);
        });
    }

    protected processPageStockOutOrder(response: AxiosResponse): Promise<IPageOfStockOutOrderVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfStockOutOrderVO.fromJS(resultData200) : new IPageOfStockOutOrderVO();
            return result200;
        }
        return Promise.resolve<IPageOfStockOutOrderVO>(<any>null);
    }

    /**
     * 分页查询出库单-备品备件
     * @param areaId (optional) 库区Id
     * @param current (optional) 当前页
     * @param keyWord (optional) 关键词
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageStockOutOrderByType(areaId: string | null | undefined, current: number | null | undefined, keyWord: string | null | undefined, size: number | null | undefined): Promise<IPageOfStockOutOrderVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-orders/page-by-type?";
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageStockOutOrderByType(_response);
        });
    }

    protected processPageStockOutOrderByType(response: AxiosResponse): Promise<IPageOfStockOutOrderVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfStockOutOrderVO.fromJS(resultData200) : new IPageOfStockOutOrderVO();
            return result200;
        }
        return Promise.resolve<IPageOfStockOutOrderVO>(<any>null);
    }

    /**
     * 库存统计分页查询出库单记录
     * @param dto dto
     * @return OK
     */
    pageStockOutOrderRecord(dto: OutOrderRecordDTO): Promise<IPageOfOutOrderRecordVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-orders/record/page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageStockOutOrderRecord(_response);
        });
    }

    protected processPageStockOutOrderRecord(response: AxiosResponse): Promise<IPageOfOutOrderRecordVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfOutOrderRecordVO.fromJS(resultData200) : new IPageOfOutOrderRecordVO();
            return result200;
        }
        return Promise.resolve<IPageOfOutOrderRecordVO>(<any>null);
    }
}

export class StockOutPlanMaterialServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询出库计划物料
     * @param stockOutPlanId (optional) 出库计划ID
     * @return OK
     */
    listStockOutPlanMaterial(stockOutPlanId: string | null | undefined): Promise<StockOutPlanMaterialVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-plan-material/list?";
        if (stockOutPlanId !== undefined)
            url_ += "stockOutPlanId=" + encodeURIComponent("" + stockOutPlanId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListStockOutPlanMaterial(_response);
        });
    }

    protected processListStockOutPlanMaterial(response: AxiosResponse): Promise<StockOutPlanMaterialVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockOutPlanMaterialVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StockOutPlanMaterialVO[]>(<any>null);
    }

    /**
     * 分页查询出库计划物料
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @param stockOutPlanId (optional) 出库计划ID
     * @return OK
     */
    pageStockOutPlanMaterial(current: number | null | undefined, size: number | null | undefined, stockOutPlanId: string | null | undefined): Promise<IPageOfStockOutPlanMaterialVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-plan-material/page?";
        if (stockOutPlanId !== undefined)
            url_ += "stockOutPlanId=" + encodeURIComponent("" + stockOutPlanId) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageStockOutPlanMaterial(_response);
        });
    }

    protected processPageStockOutPlanMaterial(response: AxiosResponse): Promise<IPageOfStockOutPlanMaterialVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfStockOutPlanMaterialVO.fromJS(resultData200) : new IPageOfStockOutPlanMaterialVO();
            return result200;
        }
        return Promise.resolve<IPageOfStockOutPlanMaterialVO>(<any>null);
    }
}

export class StockOutPlanServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 删除出库计划
     * @param stockOutPlanIdList (optional) 出库计划Id集合
     * @return OK
     */
    deleteStockOutPlan(stockOutPlanIdList: string[] | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-plan/delete?";
        if (stockOutPlanIdList !== undefined)
            stockOutPlanIdList && stockOutPlanIdList.forEach(item => { url_ += "stockOutPlanIdList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteStockOutPlan(_response);
        });
    }

    protected processDeleteStockOutPlan(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 编辑出库计划
     * @param dto dto
     * @return OK
     */
    editStockOutPlan(dto: StockOutPlanEditDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-plan/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditStockOutPlan(_response);
        });
    }

    protected processEditStockOutPlan(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 查询单个出库计划
     * @param stockOutPlanId (optional) 出库计划ID
     * @return OK
     */
    getStockOutPlan(stockOutPlanId: string | null | undefined): Promise<StockOutPlanVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-plan/get?";
        if (stockOutPlanId !== undefined)
            url_ += "stockOutPlanId=" + encodeURIComponent("" + stockOutPlanId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockOutPlan(_response);
        });
    }

    protected processGetStockOutPlan(response: AxiosResponse): Promise<StockOutPlanVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? StockOutPlanVO.fromJS(resultData200) : new StockOutPlanVO();
            return result200;
        }
        return Promise.resolve<StockOutPlanVO>(<any>null);
    }

    /**
     * 查询出库计划计划物料
     * @param planId (optional) 生产计划Id
     * @return OK
     */
    getPlanMaterialForStockOutPlan(planId: string | null | undefined): Promise<StockOutPlanMaterialSelectionVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-plan/get-plan-material-for-stock-out-plan?";
        if (planId !== undefined)
            url_ += "planId=" + encodeURIComponent("" + planId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPlanMaterialForStockOutPlan(_response);
        });
    }

    protected processGetPlanMaterialForStockOutPlan(response: AxiosResponse): Promise<StockOutPlanMaterialSelectionVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockOutPlanMaterialSelectionVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StockOutPlanMaterialSelectionVO[]>(<any>null);
    }

    /**
     * 查询出库计划
     * @param keyWords (optional) 关键词
     * @return OK
     */
    listStockOutPlan(keyWords: string | null | undefined): Promise<StockOutPlanVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-plan/list?";
        if (keyWords !== undefined)
            url_ += "keyWords=" + encodeURIComponent("" + keyWords) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListStockOutPlan(_response);
        });
    }

    protected processListStockOutPlan(response: AxiosResponse): Promise<StockOutPlanVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockOutPlanVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StockOutPlanVO[]>(<any>null);
    }

    /**
     * 通过计划id查询出库计划
     * @param planId (optional) 生产计划Id
     * @return OK
     */
    listStockOutPlanByPlanId(planId: string | null | undefined): Promise<StockOutPlanVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-plan/list-by-plan-id?";
        if (planId !== undefined)
            url_ += "planId=" + encodeURIComponent("" + planId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListStockOutPlanByPlanId(_response);
        });
    }

    protected processListStockOutPlanByPlanId(response: AxiosResponse): Promise<StockOutPlanVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockOutPlanVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StockOutPlanVO[]>(<any>null);
    }

    /**
     * 查询出库计划（出库用）
     * @return OK
     */
    listStockOutPlanToStockOut(): Promise<StockOutPlanVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-plan/list-to-stock-out";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListStockOutPlanToStockOut(_response);
        });
    }

    protected processListStockOutPlanToStockOut(response: AxiosResponse): Promise<StockOutPlanVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockOutPlanVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StockOutPlanVO[]>(<any>null);
    }

    /**
     * 分页查询出库计划
     * @param current (optional) 当前页
     * @param keyWords (optional) 关键词
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageStockOutPlan(current: number | null | undefined, keyWords: string | null | undefined, size: number | null | undefined): Promise<IPageOfStockOutPlanVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-plan/page?";
        if (keyWords !== undefined)
            url_ += "keyWords=" + encodeURIComponent("" + keyWords) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageStockOutPlan(_response);
        });
    }

    protected processPageStockOutPlan(response: AxiosResponse): Promise<IPageOfStockOutPlanVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfStockOutPlanVO.fromJS(resultData200) : new IPageOfStockOutPlanVO();
            return result200;
        }
        return Promise.resolve<IPageOfStockOutPlanVO>(<any>null);
    }

    /**
     * 新建出库计划
     * @param dto dto
     * @return OK
     */
    createStockOutPlan(dto: StockOutPlanAddDTO): Promise<string> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-plan/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateStockOutPlan(_response);
        });
    }

    protected processCreateStockOutPlan(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * 执行出库计划
     * @param stockOutPlanStockOutSubmitDTO stockOutPlanStockOutSubmitDTO
     * @return OK
     */
    stockOut(stockOutPlanStockOutSubmitDTO: StockOutPlanStockOutSubmitDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-plan/stock-out";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockOutPlanStockOutSubmitDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processStockOut(_response);
        });
    }

    protected processStockOut(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class StockOutTypeServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增出库类型
     * @param stockOutTypeAddDTO stockOutTypeAddDTO
     * @return OK
     */
    createStockOutType(stockOutTypeAddDTO: StockOutTypeAddDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-type/create-stock-out-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockOutTypeAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateStockOutType(_response);
        });
    }

    protected processCreateStockOutType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 删除出库类型（支持批量）
     * @param ids id
     * @return OK
     */
    deleteStockOutType(ids: string[]): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-type/delete-stock-out-type?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteStockOutType(_response);
        });
    }

    protected processDeleteStockOutType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询出库类型
     * @param id id
     * @return OK
     */
    getStockOutType(id: string): Promise<StockOutTypeVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-type/get-stock-out-type?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockOutType(_response);
        });
    }

    protected processGetStockOutType(response: AxiosResponse): Promise<StockOutTypeVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? StockOutTypeVo.fromJS(resultData200) : new StockOutTypeVo();
            return result200;
        }
        return Promise.resolve<StockOutTypeVo>(<any>null);
    }

    /**
     * 查询出库类型列表（不分页）
     * @return OK
     */
    getStockOutTypeList(): Promise<StockOutTypeVo[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-type/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetStockOutTypeList(_response);
        });
    }

    protected processGetStockOutTypeList(response: AxiosResponse): Promise<StockOutTypeVo[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockOutTypeVo.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StockOutTypeVo[]>(<any>null);
    }

    /**
     * OpenApi新增出库类型
     * @param stockOutTypeAddDTO stockOutTypeAddDTO
     * @return OK
     */
    createStockOutTypeForOpenApi(stockOutTypeAddDTO: StockOutTypeAddOpenApiDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-type/open-api/create-stock-out-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockOutTypeAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateStockOutTypeForOpenApi(_response);
        });
    }

    protected processCreateStockOutTypeForOpenApi(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * OpenApi修改出库类型
     * @param stockOutTypeUpdateDTO stockOutTypeUpdateDTO
     * @return OK
     */
    updateStockOutTypeForOpenApi(stockOutTypeUpdateDTO: StockOutTypeUpdateOpenApiDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-type/open-api/update-stock-out-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockOutTypeUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateStockOutTypeForOpenApi(_response);
        });
    }

    protected processUpdateStockOutTypeForOpenApi(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 查询分页
     * @param current (optional) 当前页
     * @param keyWord (optional) keyWord
     * @param size (optional) 每页的数量
     * @return OK
     */
    getPageStockOutType(current: number | null | undefined, keyWord: string | null | undefined, size: number | null | undefined): Promise<IPageOfStockOutTypeVo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-type/page?";
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPageStockOutType(_response);
        });
    }

    protected processGetPageStockOutType(response: AxiosResponse): Promise<IPageOfStockOutTypeVo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfStockOutTypeVo.fromJS(resultData200) : new IPageOfStockOutTypeVo();
            return result200;
        }
        return Promise.resolve<IPageOfStockOutTypeVo>(<any>null);
    }

    /**
     * 修改出库类型
     * @param stockOutTypeUpdateDTO stockOutTypeUpdateDTO
     * @return OK
     */
    updateStockOutType(stockOutTypeUpdateDTO: StockOutTypeUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-out-type/update-stock-out-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stockOutTypeUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateStockOutType(_response);
        });
    }

    protected processUpdateStockOutType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class StockShiftOrderMaterialServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 查询移库单物料列表
     * @param id (optional) 移库单id
     * @return OK
     */
    listStockShiftOrderMaterial(id: string | null | undefined): Promise<StockShiftOrderMaterialVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-shift-order-materials/list/{id}";
        if (id !== null && id !== undefined)
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        else
            url_ = url_.replace("/{id}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListStockShiftOrderMaterial(_response);
        });
    }

    protected processListStockShiftOrderMaterial(response: AxiosResponse): Promise<StockShiftOrderMaterialVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StockShiftOrderMaterialVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<StockShiftOrderMaterialVO[]>(<any>null);
    }
}

export class StockShiftOrderServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新建移库单
     * @param dto dto
     * @return OK
     */
    createStockShiftOrder(dto: StockShiftOrderSubmitDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-shift-orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreateStockShiftOrder(_response);
        });
    }

    protected processCreateStockShiftOrder(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 分页查询移库单列表
     * @param areaId (optional) areaId
     * @param current (optional) 当前页
     * @param keyWord (optional) keyWord
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageStockShiftOrder(areaId: string | null | undefined, current: number | null | undefined, keyWord: string | null | undefined, size: number | null | undefined): Promise<IPageOfStockShiftOrderVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-shift-orders/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        if (keyWord !== undefined)
            url_ += "keyWord=" + encodeURIComponent("" + keyWord) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageStockShiftOrder(_response);
        });
    }

    protected processPageStockShiftOrder(response: AxiosResponse): Promise<IPageOfStockShiftOrderVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfStockShiftOrderVO.fromJS(resultData200) : new IPageOfStockShiftOrderVO();
            return result200;
        }
        return Promise.resolve<IPageOfStockShiftOrderVO>(<any>null);
    }

    /**
     * 分页查询移库记录
     * @param dto dto
     * @return OK
     */
    pageStockShiftOrderRecord(dto: ShiftOrderRecordDTO): Promise<IPageOfShiftOrderRecordVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-shift-orders/record/page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageStockShiftOrderRecord(_response);
        });
    }

    protected processPageStockShiftOrderRecord(response: AxiosResponse): Promise<IPageOfShiftOrderRecordVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfShiftOrderRecordVO.fromJS(resultData200) : new IPageOfShiftOrderRecordVO();
            return result200;
        }
        return Promise.resolve<IPageOfShiftOrderRecordVO>(<any>null);
    }
}

export class StockShiftOrderExcelServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出移库记录
     * @param areaId (optional) areaId
     * @return OK
     */
    exportProduct(areaId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/app-wms')+ "/stock-shift-record/excels/export?";
        if (areaId !== undefined)
            url_ += "areaId=" + encodeURIComponent("" + areaId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportProduct(_response);
        });
    }

    protected processExportProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class GatewayFilterDefinition implements IGatewayFilterDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayFilterDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayFilterDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayFilterDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayFilterDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GatewayPredicateDefinition implements IGatewayPredicateDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayPredicateDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayPredicateDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPredicateDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayPredicateDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class IPageOfInOrderRecordVO implements IIPageOfInOrderRecordVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: InOrderRecordVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfInOrderRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(InOrderRecordVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfInOrderRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfInOrderRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfInOrderRecordVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: InOrderRecordVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfOutOrderRecordVO implements IIPageOfOutOrderRecordVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: OutOrderRecordVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfOutOrderRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(OutOrderRecordVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfOutOrderRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfOutOrderRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfOutOrderRecordVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: OutOrderRecordVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfShiftOrderRecordVO implements IIPageOfShiftOrderRecordVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: ShiftOrderRecordVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfShiftOrderRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(ShiftOrderRecordVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfShiftOrderRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfShiftOrderRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfShiftOrderRecordVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: ShiftOrderRecordVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfStockInOrderMaterialVo implements IIPageOfStockInOrderMaterialVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: StockInOrderMaterialVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfStockInOrderMaterialVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(StockInOrderMaterialVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfStockInOrderMaterialVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfStockInOrderMaterialVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfStockInOrderMaterialVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: StockInOrderMaterialVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfStockInOrderVo implements IIPageOfStockInOrderVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: StockInOrderVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfStockInOrderVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(StockInOrderVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfStockInOrderVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfStockInOrderVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfStockInOrderVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: StockInOrderVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfStockInTypeVo implements IIPageOfStockInTypeVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: StockInTypeVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfStockInTypeVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(StockInTypeVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfStockInTypeVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfStockInTypeVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfStockInTypeVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: StockInTypeVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfStockOutOrderVO implements IIPageOfStockOutOrderVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: StockOutOrderVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfStockOutOrderVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(StockOutOrderVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfStockOutOrderVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfStockOutOrderVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfStockOutOrderVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: StockOutOrderVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfStockOutPlanMaterialVO implements IIPageOfStockOutPlanMaterialVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: StockOutPlanMaterialVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfStockOutPlanMaterialVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(StockOutPlanMaterialVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfStockOutPlanMaterialVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfStockOutPlanMaterialVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfStockOutPlanMaterialVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: StockOutPlanMaterialVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfStockOutPlanVO implements IIPageOfStockOutPlanVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: StockOutPlanVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfStockOutPlanVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(StockOutPlanVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfStockOutPlanVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfStockOutPlanVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfStockOutPlanVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: StockOutPlanVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfStockOutTypeVo implements IIPageOfStockOutTypeVo {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: StockOutTypeVo[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfStockOutTypeVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(StockOutTypeVo.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfStockOutTypeVo {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfStockOutTypeVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfStockOutTypeVo {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: StockOutTypeVo[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfStockShiftOrderVO implements IIPageOfStockShiftOrderVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: StockShiftOrderVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfStockShiftOrderVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(StockShiftOrderVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfStockShiftOrderVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfStockShiftOrderVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfStockShiftOrderVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: StockShiftOrderVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

/** 入库单记录信息 */
export class InOrderRecordVO implements IInOrderRecordVO {
    /** 物料批号 */
    batchCode!: string | undefined;
    /** 责任人 */
    deliveryUser!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 入库单编号 */
    inOrderCode!: string | undefined;
    /** 入库单名称 */
    inOrderName!: string | undefined;
    /** 出库单编号 */
    outOrderCode!: string | undefined;
    /** 生产计划号 */
    planCode!: string | undefined;
    /** 入库人员 */
    receivingUser!: string | undefined;
    /** 入库数量 */
    stockInNum!: number | undefined;
    /** 入库时间 */
    stockInTime!: Date | undefined;
    /** 入库类型 */
    stockInType!: string | undefined;

    constructor(data?: IInOrderRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.batchCode = data["batchCode"];
            this.deliveryUser = data["deliveryUser"];
            this.id = data["id"];
            this.inOrderCode = data["inOrderCode"];
            this.inOrderName = data["inOrderName"];
            this.outOrderCode = data["outOrderCode"];
            this.planCode = data["planCode"];
            this.receivingUser = data["receivingUser"];
            this.stockInNum = data["stockInNum"];
            this.stockInTime = data["stockInTime"] ? new Date(data["stockInTime"].toString()) : <any>undefined;
            this.stockInType = data["stockInType"];
        }
    }

    static fromJS(data: any): InOrderRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new InOrderRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchCode"] = this.batchCode;
        data["deliveryUser"] = this.deliveryUser;
        data["id"] = this.id;
        data["inOrderCode"] = this.inOrderCode;
        data["inOrderName"] = this.inOrderName;
        data["outOrderCode"] = this.outOrderCode;
        data["planCode"] = this.planCode;
        data["receivingUser"] = this.receivingUser;
        data["stockInNum"] = this.stockInNum;
        data["stockInTime"] = this.stockInTime ? this.stockInTime.toISOString() : <any>undefined;
        data["stockInType"] = this.stockInType;
        return data; 
    }
}

/** 入库单记录信息 */
export interface IInOrderRecordVO {
    /** 物料批号 */
    batchCode: string | undefined;
    /** 责任人 */
    deliveryUser: string | undefined;
    /** id */
    id: string | undefined;
    /** 入库单编号 */
    inOrderCode: string | undefined;
    /** 入库单名称 */
    inOrderName: string | undefined;
    /** 出库单编号 */
    outOrderCode: string | undefined;
    /** 生产计划号 */
    planCode: string | undefined;
    /** 入库人员 */
    receivingUser: string | undefined;
    /** 入库数量 */
    stockInNum: number | undefined;
    /** 入库时间 */
    stockInTime: Date | undefined;
    /** 入库类型 */
    stockInType: string | undefined;
}

export class OutMaterialsVO implements IOutMaterialsVO {
    /** 所属库位Id */
    areaId!: string | undefined;
    /** 所属库区名称 */
    areaName!: string | undefined;
    /** 物料条码 */
    barCode!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck!: number | undefined;
    /** 所属库位Id */
    locationId!: string | undefined;
    /** 所属库区名称 */
    locationName!: string | undefined;
    /** 额定库存 */
    lowerLimit!: number | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 物料性质：1-原材料、2-半成品、3-成品、4-备品备件、5-辅助用品、9-其它 */
    property!: number | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 退库数量 */
    returnNum!: number | undefined;
    /** 规格 */
    standardModel!: string | undefined;
    /** 出库数量 */
    stockOutNum!: number | undefined;
    /** 材质 */
    stuff!: string | undefined;
    /** 物料类型Id */
    typeId!: string | undefined;
    /** 物料类型名称 */
    typeName!: string | undefined;
    /** 计量单位 */
    unit!: string | undefined;
    /** 安全库存 */
    upperLimit!: number | undefined;

    constructor(data?: IOutMaterialsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.areaName = data["areaName"];
            this.barCode = data["barCode"];
            this.id = data["id"];
            this.isMustCheck = data["isMustCheck"];
            this.locationId = data["locationId"];
            this.locationName = data["locationName"];
            this.lowerLimit = data["lowerLimit"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.property = data["property"];
            this.remark = data["remark"];
            this.returnNum = data["returnNum"];
            this.standardModel = data["standardModel"];
            this.stockOutNum = data["stockOutNum"];
            this.stuff = data["stuff"];
            this.typeId = data["typeId"];
            this.typeName = data["typeName"];
            this.unit = data["unit"];
            this.upperLimit = data["upperLimit"];
        }
    }

    static fromJS(data: any): OutMaterialsVO {
        data = typeof data === 'object' ? data : {};
        let result = new OutMaterialsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["barCode"] = this.barCode;
        data["id"] = this.id;
        data["isMustCheck"] = this.isMustCheck;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["lowerLimit"] = this.lowerLimit;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["property"] = this.property;
        data["remark"] = this.remark;
        data["returnNum"] = this.returnNum;
        data["standardModel"] = this.standardModel;
        data["stockOutNum"] = this.stockOutNum;
        data["stuff"] = this.stuff;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["unit"] = this.unit;
        data["upperLimit"] = this.upperLimit;
        return data; 
    }
}

export interface IOutMaterialsVO {
    /** 所属库位Id */
    areaId: string | undefined;
    /** 所属库区名称 */
    areaName: string | undefined;
    /** 物料条码 */
    barCode: string | undefined;
    /** id */
    id: string | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck: number | undefined;
    /** 所属库位Id */
    locationId: string | undefined;
    /** 所属库区名称 */
    locationName: string | undefined;
    /** 额定库存 */
    lowerLimit: number | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 物料性质：1-原材料、2-半成品、3-成品、4-备品备件、5-辅助用品、9-其它 */
    property: number | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 退库数量 */
    returnNum: number | undefined;
    /** 规格 */
    standardModel: string | undefined;
    /** 出库数量 */
    stockOutNum: number | undefined;
    /** 材质 */
    stuff: string | undefined;
    /** 物料类型Id */
    typeId: string | undefined;
    /** 物料类型名称 */
    typeName: string | undefined;
    /** 计量单位 */
    unit: string | undefined;
    /** 安全库存 */
    upperLimit: number | undefined;
}

export class OutOrderPlanVO implements IOutOrderPlanVO {
    /** 出库单id */
    id!: string | undefined;
    /** 出库单code */
    orderCode!: string | undefined;

    constructor(data?: IOutOrderPlanVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.orderCode = data["orderCode"];
        }
    }

    static fromJS(data: any): OutOrderPlanVO {
        data = typeof data === 'object' ? data : {};
        let result = new OutOrderPlanVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderCode"] = this.orderCode;
        return data; 
    }
}

export interface IOutOrderPlanVO {
    /** 出库单id */
    id: string | undefined;
    /** 出库单code */
    orderCode: string | undefined;
}

/** 查询出库单物料DTO */
export class OutOrderRecordDTO implements IOutOrderRecordDTO {
    /** 库区id */
    areaId!: string;
    /** 库位id */
    locationId!: string;
    /** 物料id */
    materialId!: string;
    /** 分页 */
    query!: Query | undefined;

    constructor(data?: IOutOrderRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.locationId = data["locationId"];
            this.materialId = data["materialId"];
            this.query = data["query"] ? Query.fromJS(data["query"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OutOrderRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OutOrderRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["locationId"] = this.locationId;
        data["materialId"] = this.materialId;
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        return data; 
    }
}

/** 查询出库单物料DTO */
export interface IOutOrderRecordDTO {
    /** 库区id */
    areaId: string;
    /** 库位id */
    locationId: string;
    /** 物料id */
    materialId: string;
    /** 分页 */
    query: Query | undefined;
}

/** 出库单记录 */
export class OutOrderRecordVO implements IOutOrderRecordVO {
    /** id */
    id!: string | undefined;
    /** 出库单编号 */
    orderCode!: string | undefined;
    /** 出库单名称 */
    orderName!: string | undefined;
    /** 计划单号 */
    planCode!: string | undefined;
    /** 退库数量 */
    returnedNum!: number | undefined;
    /** 出库数量 */
    stockOutNum!: number | undefined;
    /** 出库计划编码 */
    stockOutPlanCode!: string | undefined;
    /** 出库计划ID */
    stockOutPlanId!: string | undefined;
    /** 出库时间 */
    stockOutTime!: Date | undefined;
    /** 出库类型 */
    stockOutType!: string | undefined;
    /** 出库人员id */
    stockOutUser!: string | undefined;

    constructor(data?: IOutOrderRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.orderCode = data["orderCode"];
            this.orderName = data["orderName"];
            this.planCode = data["planCode"];
            this.returnedNum = data["returnedNum"];
            this.stockOutNum = data["stockOutNum"];
            this.stockOutPlanCode = data["stockOutPlanCode"];
            this.stockOutPlanId = data["stockOutPlanId"];
            this.stockOutTime = data["stockOutTime"] ? new Date(data["stockOutTime"].toString()) : <any>undefined;
            this.stockOutType = data["stockOutType"];
            this.stockOutUser = data["stockOutUser"];
        }
    }

    static fromJS(data: any): OutOrderRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new OutOrderRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderCode"] = this.orderCode;
        data["orderName"] = this.orderName;
        data["planCode"] = this.planCode;
        data["returnedNum"] = this.returnedNum;
        data["stockOutNum"] = this.stockOutNum;
        data["stockOutPlanCode"] = this.stockOutPlanCode;
        data["stockOutPlanId"] = this.stockOutPlanId;
        data["stockOutTime"] = this.stockOutTime ? this.stockOutTime.toISOString() : <any>undefined;
        data["stockOutType"] = this.stockOutType;
        data["stockOutUser"] = this.stockOutUser;
        return data; 
    }
}

/** 出库单记录 */
export interface IOutOrderRecordVO {
    /** id */
    id: string | undefined;
    /** 出库单编号 */
    orderCode: string | undefined;
    /** 出库单名称 */
    orderName: string | undefined;
    /** 计划单号 */
    planCode: string | undefined;
    /** 退库数量 */
    returnedNum: number | undefined;
    /** 出库数量 */
    stockOutNum: number | undefined;
    /** 出库计划编码 */
    stockOutPlanCode: string | undefined;
    /** 出库计划ID */
    stockOutPlanId: string | undefined;
    /** 出库时间 */
    stockOutTime: Date | undefined;
    /** 出库类型 */
    stockOutType: string | undefined;
    /** 出库人员id */
    stockOutUser: string | undefined;
}

/** 查询条件 */
export class Query implements IQuery {
    /** 当前页 */
    current!: number | undefined;
    /** 每页的数量 */
    size!: number | undefined;

    constructor(data?: IQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): Query {
        data = typeof data === 'object' ? data : {};
        let result = new Query();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["size"] = this.size;
        return data; 
    }
}

/** 查询条件 */
export interface IQuery {
    /** 当前页 */
    current: number | undefined;
    /** 每页的数量 */
    size: number | undefined;
}

export class RouteDefinition implements IRouteDefinition {
    compatibleMode!: number | undefined;
    filters!: GatewayFilterDefinition[] | undefined;
    id!: string | undefined;
    ignoreValidate!: number | undefined;
    mergeResult!: number | undefined;
    name!: string | undefined;
    needToken!: number | undefined;
    order!: number | undefined;
    path!: string | undefined;
    permission!: number | undefined;
    predicates!: GatewayPredicateDefinition[] | undefined;
    status!: number | undefined;
    uri!: string | undefined;
    version!: string | undefined;

    constructor(data?: IRouteDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.compatibleMode = data["compatibleMode"];
            if (data["filters"] && data["filters"].constructor === Array) {
                this.filters = [] as any;
                for (let item of data["filters"])
                    this.filters!.push(GatewayFilterDefinition.fromJS(item));
            }
            this.id = data["id"];
            this.ignoreValidate = data["ignoreValidate"];
            this.mergeResult = data["mergeResult"];
            this.name = data["name"];
            this.needToken = data["needToken"];
            this.order = data["order"];
            this.path = data["path"];
            this.permission = data["permission"];
            if (data["predicates"] && data["predicates"].constructor === Array) {
                this.predicates = [] as any;
                for (let item of data["predicates"])
                    this.predicates!.push(GatewayPredicateDefinition.fromJS(item));
            }
            this.status = data["status"];
            this.uri = data["uri"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): RouteDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new RouteDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compatibleMode"] = this.compatibleMode;
        if (this.filters && this.filters.constructor === Array) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["ignoreValidate"] = this.ignoreValidate;
        data["mergeResult"] = this.mergeResult;
        data["name"] = this.name;
        data["needToken"] = this.needToken;
        data["order"] = this.order;
        data["path"] = this.path;
        data["permission"] = this.permission;
        if (this.predicates && this.predicates.constructor === Array) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["uri"] = this.uri;
        data["version"] = this.version;
        return data; 
    }
}

export interface IRouteDefinition {
    compatibleMode: number | undefined;
    filters: GatewayFilterDefinition[] | undefined;
    id: string | undefined;
    ignoreValidate: number | undefined;
    mergeResult: number | undefined;
    name: string | undefined;
    needToken: number | undefined;
    order: number | undefined;
    path: string | undefined;
    permission: number | undefined;
    predicates: GatewayPredicateDefinition[] | undefined;
    status: number | undefined;
    uri: string | undefined;
    version: string | undefined;
}

export class ServiceRouteInfo implements IServiceRouteInfo {
    createTime!: Date | undefined;
    description!: string | undefined;
    routeDefinitionList!: RouteDefinition[] | undefined;
    serviceId!: string | undefined;
    updateTime!: Date | undefined;

    constructor(data?: IServiceRouteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.description = data["description"];
            if (data["routeDefinitionList"] && data["routeDefinitionList"].constructor === Array) {
                this.routeDefinitionList = [] as any;
                for (let item of data["routeDefinitionList"])
                    this.routeDefinitionList!.push(RouteDefinition.fromJS(item));
            }
            this.serviceId = data["serviceId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceRouteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRouteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (this.routeDefinitionList && this.routeDefinitionList.constructor === Array) {
            data["routeDefinitionList"] = [];
            for (let item of this.routeDefinitionList)
                data["routeDefinitionList"].push(item.toJSON());
        }
        data["serviceId"] = this.serviceId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IServiceRouteInfo {
    createTime: Date | undefined;
    description: string | undefined;
    routeDefinitionList: RouteDefinition[] | undefined;
    serviceId: string | undefined;
    updateTime: Date | undefined;
}

/** 移库单记录DTO */
export class ShiftOrderRecordDTO implements IShiftOrderRecordDTO {
    /** 库区id */
    areaId!: string | undefined;
    /** 关键词搜索 */
    keyWord!: string | undefined;
    /** 分页 */
    query!: Query | undefined;

    constructor(data?: IShiftOrderRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.keyWord = data["keyWord"];
            this.query = data["query"] ? Query.fromJS(data["query"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ShiftOrderRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftOrderRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["keyWord"] = this.keyWord;
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        return data; 
    }
}

/** 移库单记录DTO */
export interface IShiftOrderRecordDTO {
    /** 库区id */
    areaId: string | undefined;
    /** 关键词搜索 */
    keyWord: string | undefined;
    /** 分页 */
    query: Query | undefined;
}

/** 移库记录信息 */
export class ShiftOrderRecordVO implements IShiftOrderRecordVO {
    /** 源库区 */
    fromAreaName!: string | undefined;
    /** 源库位 */
    fromLocationName!: string | undefined;
    /** 源库区库位的库存数量 */
    fromStockNum!: number | undefined;
    /** 移库单id */
    id!: string | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 规格型号 */
    materialStandardModel!: string | undefined;
    /** 计量单位 */
    materialUnit!: string | undefined;
    /** 移库单编号 */
    orderCode!: string | undefined;
    /** 移库说明 */
    remark!: string | undefined;
    /** 移库部门 */
    shiftDept!: string | undefined;
    /** 移库数量 */
    shiftNum!: number | undefined;
    /** 移库时间 */
    shiftTime!: Date | undefined;
    /** 移库人员 */
    shiftUser!: string | undefined;
    /** 入库类型 */
    stockInType!: string | undefined;
    /** 出库类型 */
    stockOutType!: string | undefined;
    /** 目标库区 */
    toAreaName!: string | undefined;
    /** 目标库位 */
    toLocationName!: string | undefined;
    /** 目标库区库位的库存数量 */
    toStockNum!: number | undefined;

    constructor(data?: IShiftOrderRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fromAreaName = data["fromAreaName"];
            this.fromLocationName = data["fromLocationName"];
            this.fromStockNum = data["fromStockNum"];
            this.id = data["id"];
            this.materialCode = data["materialCode"];
            this.materialName = data["materialName"];
            this.materialStandardModel = data["materialStandardModel"];
            this.materialUnit = data["materialUnit"];
            this.orderCode = data["orderCode"];
            this.remark = data["remark"];
            this.shiftDept = data["shiftDept"];
            this.shiftNum = data["shiftNum"];
            this.shiftTime = data["shiftTime"] ? new Date(data["shiftTime"].toString()) : <any>undefined;
            this.shiftUser = data["shiftUser"];
            this.stockInType = data["stockInType"];
            this.stockOutType = data["stockOutType"];
            this.toAreaName = data["toAreaName"];
            this.toLocationName = data["toLocationName"];
            this.toStockNum = data["toStockNum"];
        }
    }

    static fromJS(data: any): ShiftOrderRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftOrderRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromAreaName"] = this.fromAreaName;
        data["fromLocationName"] = this.fromLocationName;
        data["fromStockNum"] = this.fromStockNum;
        data["id"] = this.id;
        data["materialCode"] = this.materialCode;
        data["materialName"] = this.materialName;
        data["materialStandardModel"] = this.materialStandardModel;
        data["materialUnit"] = this.materialUnit;
        data["orderCode"] = this.orderCode;
        data["remark"] = this.remark;
        data["shiftDept"] = this.shiftDept;
        data["shiftNum"] = this.shiftNum;
        data["shiftTime"] = this.shiftTime ? this.shiftTime.toISOString() : <any>undefined;
        data["shiftUser"] = this.shiftUser;
        data["stockInType"] = this.stockInType;
        data["stockOutType"] = this.stockOutType;
        data["toAreaName"] = this.toAreaName;
        data["toLocationName"] = this.toLocationName;
        data["toStockNum"] = this.toStockNum;
        return data; 
    }
}

/** 移库记录信息 */
export interface IShiftOrderRecordVO {
    /** 源库区 */
    fromAreaName: string | undefined;
    /** 源库位 */
    fromLocationName: string | undefined;
    /** 源库区库位的库存数量 */
    fromStockNum: number | undefined;
    /** 移库单id */
    id: string | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 规格型号 */
    materialStandardModel: string | undefined;
    /** 计量单位 */
    materialUnit: string | undefined;
    /** 移库单编号 */
    orderCode: string | undefined;
    /** 移库说明 */
    remark: string | undefined;
    /** 移库部门 */
    shiftDept: string | undefined;
    /** 移库数量 */
    shiftNum: number | undefined;
    /** 移库时间 */
    shiftTime: Date | undefined;
    /** 移库人员 */
    shiftUser: string | undefined;
    /** 入库类型 */
    stockInType: string | undefined;
    /** 出库类型 */
    stockOutType: string | undefined;
    /** 目标库区 */
    toAreaName: string | undefined;
    /** 目标库位 */
    toLocationName: string | undefined;
    /** 目标库区库位的库存数量 */
    toStockNum: number | undefined;
}

export class StockInOrderAddDTO implements IStockInOrderAddDTO {
    /** 库区Id */
    areaId!: string;
    /** 数据来源（1：维修；2：保养） */
    bizType!: number | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 送料单号 */
    deliveryCode!: string | undefined;
    /** 送料人员 */
    deliveryUser!: string | undefined;
    /** 送料人员名称 */
    deliveryUserName!: string | undefined;
    /** 是否关联计划：0-不关联，1-关联 */
    isPlan!: string;
    /** 模式 */
    model!: number;
    /** 入库单编号 */
    orderCode!: string | undefined;
    /** 入库单名称 */
    orderName!: string | undefined;
    /** 出库单号 */
    outOrderCode!: string | undefined;
    /** 计划单号 */
    planCode!: string | undefined;
    /** 关联计划id */
    planId!: string | undefined;
    /** 工单code */
    planOrderCode!: string | undefined;
    /** 工单id */
    planOrderId!: string | undefined;
    /** 工序编码 */
    planOrderProcessCode!: string | undefined;
    /** 工序Id */
    planOrderProcessId!: string | undefined;
    /** 工序名称 */
    planOrderProcessName!: string | undefined;
    /** 收料单号 */
    receivingCode!: string | undefined;
    /** 收料部门id */
    receivingDept!: string | undefined;
    /** 收料部门名称 */
    receivingDeptName!: string | undefined;
    /** 收料时间 */
    receivingTime!: Date;
    /** 收料人员id */
    receivingUser!: string | undefined;
    /** 收料人员名称 */
    receivingUserName!: string | undefined;
    /** 物料 */
    stockInOrderMaterialList!: StockInOrderMaterialAddDTO[] | undefined;
    /** 入库类型code */
    stockInTypeCode!: string | undefined;
    /** 入库类型id */
    stockInTypeId!: string;
    /** 入库类型名称 */
    stockInTypeName!: string | undefined;
    /** 出库计划编码 */
    stockOutPlanCode!: string | undefined;
    /** 出库计划ID */
    stockOutPlanId!: string | undefined;
    /** 供应商Id */
    supplierId!: string | undefined;
    /** 供应商名称 */
    supplierName!: string | undefined;

    constructor(data?: IStockInOrderAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.bizType = data["bizType"];
            this.codeRuleId = data["codeRuleId"];
            this.deliveryCode = data["deliveryCode"];
            this.deliveryUser = data["deliveryUser"];
            this.deliveryUserName = data["deliveryUserName"];
            this.isPlan = data["isPlan"];
            this.model = data["model"];
            this.orderCode = data["orderCode"];
            this.orderName = data["orderName"];
            this.outOrderCode = data["outOrderCode"];
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.planOrderCode = data["planOrderCode"];
            this.planOrderId = data["planOrderId"];
            this.planOrderProcessCode = data["planOrderProcessCode"];
            this.planOrderProcessId = data["planOrderProcessId"];
            this.planOrderProcessName = data["planOrderProcessName"];
            this.receivingCode = data["receivingCode"];
            this.receivingDept = data["receivingDept"];
            this.receivingDeptName = data["receivingDeptName"];
            this.receivingTime = data["receivingTime"] ? new Date(data["receivingTime"].toString()) : <any>undefined;
            this.receivingUser = data["receivingUser"];
            this.receivingUserName = data["receivingUserName"];
            if (data["stockInOrderMaterialList"] && data["stockInOrderMaterialList"].constructor === Array) {
                this.stockInOrderMaterialList = [] as any;
                for (let item of data["stockInOrderMaterialList"])
                    this.stockInOrderMaterialList!.push(StockInOrderMaterialAddDTO.fromJS(item));
            }
            this.stockInTypeCode = data["stockInTypeCode"];
            this.stockInTypeId = data["stockInTypeId"];
            this.stockInTypeName = data["stockInTypeName"];
            this.stockOutPlanCode = data["stockOutPlanCode"];
            this.stockOutPlanId = data["stockOutPlanId"];
            this.supplierId = data["supplierId"];
            this.supplierName = data["supplierName"];
        }
    }

    static fromJS(data: any): StockInOrderAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockInOrderAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["bizType"] = this.bizType;
        data["codeRuleId"] = this.codeRuleId;
        data["deliveryCode"] = this.deliveryCode;
        data["deliveryUser"] = this.deliveryUser;
        data["deliveryUserName"] = this.deliveryUserName;
        data["isPlan"] = this.isPlan;
        data["model"] = this.model;
        data["orderCode"] = this.orderCode;
        data["orderName"] = this.orderName;
        data["outOrderCode"] = this.outOrderCode;
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["planOrderCode"] = this.planOrderCode;
        data["planOrderId"] = this.planOrderId;
        data["planOrderProcessCode"] = this.planOrderProcessCode;
        data["planOrderProcessId"] = this.planOrderProcessId;
        data["planOrderProcessName"] = this.planOrderProcessName;
        data["receivingCode"] = this.receivingCode;
        data["receivingDept"] = this.receivingDept;
        data["receivingDeptName"] = this.receivingDeptName;
        data["receivingTime"] = this.receivingTime ? this.receivingTime.toISOString() : <any>undefined;
        data["receivingUser"] = this.receivingUser;
        data["receivingUserName"] = this.receivingUserName;
        if (this.stockInOrderMaterialList && this.stockInOrderMaterialList.constructor === Array) {
            data["stockInOrderMaterialList"] = [];
            for (let item of this.stockInOrderMaterialList)
                data["stockInOrderMaterialList"].push(item.toJSON());
        }
        data["stockInTypeCode"] = this.stockInTypeCode;
        data["stockInTypeId"] = this.stockInTypeId;
        data["stockInTypeName"] = this.stockInTypeName;
        data["stockOutPlanCode"] = this.stockOutPlanCode;
        data["stockOutPlanId"] = this.stockOutPlanId;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        return data; 
    }
}

export interface IStockInOrderAddDTO {
    /** 库区Id */
    areaId: string;
    /** 数据来源（1：维修；2：保养） */
    bizType: number | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 送料单号 */
    deliveryCode: string | undefined;
    /** 送料人员 */
    deliveryUser: string | undefined;
    /** 送料人员名称 */
    deliveryUserName: string | undefined;
    /** 是否关联计划：0-不关联，1-关联 */
    isPlan: string;
    /** 模式 */
    model: number;
    /** 入库单编号 */
    orderCode: string | undefined;
    /** 入库单名称 */
    orderName: string | undefined;
    /** 出库单号 */
    outOrderCode: string | undefined;
    /** 计划单号 */
    planCode: string | undefined;
    /** 关联计划id */
    planId: string | undefined;
    /** 工单code */
    planOrderCode: string | undefined;
    /** 工单id */
    planOrderId: string | undefined;
    /** 工序编码 */
    planOrderProcessCode: string | undefined;
    /** 工序Id */
    planOrderProcessId: string | undefined;
    /** 工序名称 */
    planOrderProcessName: string | undefined;
    /** 收料单号 */
    receivingCode: string | undefined;
    /** 收料部门id */
    receivingDept: string | undefined;
    /** 收料部门名称 */
    receivingDeptName: string | undefined;
    /** 收料时间 */
    receivingTime: Date;
    /** 收料人员id */
    receivingUser: string | undefined;
    /** 收料人员名称 */
    receivingUserName: string | undefined;
    /** 物料 */
    stockInOrderMaterialList: StockInOrderMaterialAddDTO[] | undefined;
    /** 入库类型code */
    stockInTypeCode: string | undefined;
    /** 入库类型id */
    stockInTypeId: string;
    /** 入库类型名称 */
    stockInTypeName: string | undefined;
    /** 出库计划编码 */
    stockOutPlanCode: string | undefined;
    /** 出库计划ID */
    stockOutPlanId: string | undefined;
    /** 供应商Id */
    supplierId: string | undefined;
    /** 供应商名称 */
    supplierName: string | undefined;
}

export class StockInOrderMaterialAddDTO implements IStockInOrderMaterialAddDTO {
    /** 所属库区Id */
    areaId!: string;
    /** 所属库区名称 */
    areaName!: string | undefined;
    /** 物料批号 */
    batchCode!: string | undefined;
    /** 文件mini类型 */
    contentType!: string | undefined;
    /** 检测文件名 */
    fileName!: string | undefined;
    /** 文件key */
    fileObjectKey!: string | undefined;
    /** 所属库位Id */
    locationId!: string;
    /** 所属库位名称 */
    locationName!: string | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 所属物料Id */
    materialId!: string;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 物料规格 */
    materialStandardModel!: string | undefined;
    /** 入库状态：0-未入库，1-已入库 */
    materialStatus!: number | undefined;
    /** 物料材质 */
    materialStuff!: string | undefined;
    /** 物料类型名称 */
    materialTypeName!: string | undefined;
    /** 物料计量单位 */
    materialUnit!: string | undefined;
    /** 所属入库单id */
    orderId!: string | undefined;
    /** 计划物料Id(计划物料需求清单里的Id字段) */
    planMaterialId!: string | undefined;
    /** 物料价格 */
    price!: number | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 实收数量 */
    stockInNum!: number;
    /** 出库数量 */
    stockOutNum!: number | undefined;
    /** 供应商Id */
    supplierId!: string | undefined;
    /** 检验结果：0-失败，1-成功 */
    testResult!: number | undefined;
    /** 应收数量 */
    totalNum!: number | undefined;

    constructor(data?: IStockInOrderMaterialAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.areaName = data["areaName"];
            this.batchCode = data["batchCode"];
            this.contentType = data["contentType"];
            this.fileName = data["fileName"];
            this.fileObjectKey = data["fileObjectKey"];
            this.locationId = data["locationId"];
            this.locationName = data["locationName"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.materialStandardModel = data["materialStandardModel"];
            this.materialStatus = data["materialStatus"];
            this.materialStuff = data["materialStuff"];
            this.materialTypeName = data["materialTypeName"];
            this.materialUnit = data["materialUnit"];
            this.orderId = data["orderId"];
            this.planMaterialId = data["planMaterialId"];
            this.price = data["price"];
            this.remark = data["remark"];
            this.stockInNum = data["stockInNum"];
            this.stockOutNum = data["stockOutNum"];
            this.supplierId = data["supplierId"];
            this.testResult = data["testResult"];
            this.totalNum = data["totalNum"];
        }
    }

    static fromJS(data: any): StockInOrderMaterialAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockInOrderMaterialAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["batchCode"] = this.batchCode;
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        data["fileObjectKey"] = this.fileObjectKey;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialStandardModel"] = this.materialStandardModel;
        data["materialStatus"] = this.materialStatus;
        data["materialStuff"] = this.materialStuff;
        data["materialTypeName"] = this.materialTypeName;
        data["materialUnit"] = this.materialUnit;
        data["orderId"] = this.orderId;
        data["planMaterialId"] = this.planMaterialId;
        data["price"] = this.price;
        data["remark"] = this.remark;
        data["stockInNum"] = this.stockInNum;
        data["stockOutNum"] = this.stockOutNum;
        data["supplierId"] = this.supplierId;
        data["testResult"] = this.testResult;
        data["totalNum"] = this.totalNum;
        return data; 
    }
}

export interface IStockInOrderMaterialAddDTO {
    /** 所属库区Id */
    areaId: string;
    /** 所属库区名称 */
    areaName: string | undefined;
    /** 物料批号 */
    batchCode: string | undefined;
    /** 文件mini类型 */
    contentType: string | undefined;
    /** 检测文件名 */
    fileName: string | undefined;
    /** 文件key */
    fileObjectKey: string | undefined;
    /** 所属库位Id */
    locationId: string;
    /** 所属库位名称 */
    locationName: string | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 所属物料Id */
    materialId: string;
    /** 物料名称 */
    materialName: string | undefined;
    /** 物料规格 */
    materialStandardModel: string | undefined;
    /** 入库状态：0-未入库，1-已入库 */
    materialStatus: number | undefined;
    /** 物料材质 */
    materialStuff: string | undefined;
    /** 物料类型名称 */
    materialTypeName: string | undefined;
    /** 物料计量单位 */
    materialUnit: string | undefined;
    /** 所属入库单id */
    orderId: string | undefined;
    /** 计划物料Id(计划物料需求清单里的Id字段) */
    planMaterialId: string | undefined;
    /** 物料价格 */
    price: number | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 实收数量 */
    stockInNum: number;
    /** 出库数量 */
    stockOutNum: number | undefined;
    /** 供应商Id */
    supplierId: string | undefined;
    /** 检验结果：0-失败，1-成功 */
    testResult: number | undefined;
    /** 应收数量 */
    totalNum: number | undefined;
}

export class StockInOrderMaterialUpdateDTO implements IStockInOrderMaterialUpdateDTO {
    /** 所属库区Id */
    areaId!: string;
    /** 所属库区名称 */
    areaName!: string;
    /** 物料批号 */
    batchCode!: string | undefined;
    /** 文件mini类型 */
    contentType!: string | undefined;
    /** 检测文件名 */
    fileName!: string | undefined;
    /** 文件key */
    fileObjectKey!: string | undefined;
    /** id */
    id!: string;
    /** 所属库区Id */
    locationId!: string;
    /** 所属库区Id */
    locationName!: string;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 所属物料Id */
    materialId!: string;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 入库状态：0-未入库，1-已入库 */
    materialStatus!: number | undefined;
    /** 所属入库单id */
    orderId!: string;
    /** 物料价格 */
    price!: number | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 实收数量 */
    stockInNum!: number | undefined;
    /** 供应商Id */
    supplierId!: string | undefined;
    /** 检验结果：0-失败，1-成功 */
    testResult!: number | undefined;
    /** 应收数量 */
    totalNum!: number | undefined;

    constructor(data?: IStockInOrderMaterialUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.areaName = data["areaName"];
            this.batchCode = data["batchCode"];
            this.contentType = data["contentType"];
            this.fileName = data["fileName"];
            this.fileObjectKey = data["fileObjectKey"];
            this.id = data["id"];
            this.locationId = data["locationId"];
            this.locationName = data["locationName"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.materialStatus = data["materialStatus"];
            this.orderId = data["orderId"];
            this.price = data["price"];
            this.remark = data["remark"];
            this.stockInNum = data["stockInNum"];
            this.supplierId = data["supplierId"];
            this.testResult = data["testResult"];
            this.totalNum = data["totalNum"];
        }
    }

    static fromJS(data: any): StockInOrderMaterialUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockInOrderMaterialUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["batchCode"] = this.batchCode;
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        data["fileObjectKey"] = this.fileObjectKey;
        data["id"] = this.id;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialStatus"] = this.materialStatus;
        data["orderId"] = this.orderId;
        data["price"] = this.price;
        data["remark"] = this.remark;
        data["stockInNum"] = this.stockInNum;
        data["supplierId"] = this.supplierId;
        data["testResult"] = this.testResult;
        data["totalNum"] = this.totalNum;
        return data; 
    }
}

export interface IStockInOrderMaterialUpdateDTO {
    /** 所属库区Id */
    areaId: string;
    /** 所属库区名称 */
    areaName: string;
    /** 物料批号 */
    batchCode: string | undefined;
    /** 文件mini类型 */
    contentType: string | undefined;
    /** 检测文件名 */
    fileName: string | undefined;
    /** 文件key */
    fileObjectKey: string | undefined;
    /** id */
    id: string;
    /** 所属库区Id */
    locationId: string;
    /** 所属库区Id */
    locationName: string;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 所属物料Id */
    materialId: string;
    /** 物料名称 */
    materialName: string | undefined;
    /** 入库状态：0-未入库，1-已入库 */
    materialStatus: number | undefined;
    /** 所属入库单id */
    orderId: string;
    /** 物料价格 */
    price: number | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 实收数量 */
    stockInNum: number | undefined;
    /** 供应商Id */
    supplierId: string | undefined;
    /** 检验结果：0-失败，1-成功 */
    testResult: number | undefined;
    /** 应收数量 */
    totalNum: number | undefined;
}

export class StockInOrderMaterialVo implements IStockInOrderMaterialVo {
    /** 所属库区Id */
    areaId!: string | undefined;
    /** 所属库区名称 */
    areaName!: string | undefined;
    /** 物料批号 */
    batchCode!: string | undefined;
    /** 文件mini类型 */
    contentType!: string | undefined;
    /** 自定义字段1 */
    extend1!: string | undefined;
    /** 自定义字段2 */
    extend2!: string | undefined;
    /** 自定义字段3 */
    extend3!: string | undefined;
    /** 自定义字段4 */
    extend4!: string | undefined;
    /** 自定义字段5 */
    extend5!: string | undefined;
    /** 检测文件名 */
    fileName!: string | undefined;
    /** 文件key */
    fileObjectKey!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck!: number | undefined;
    /** 是否可以查看质检单 */
    isRead!: boolean | undefined;
    /** 所属库区Id */
    locationId!: string | undefined;
    /** 所属库区名称 */
    locationName!: string | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 所属物料Id */
    materialId!: string;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 物料规格 */
    materialStandardModel!: string | undefined;
    /** 入库状态：0-未入库，1-已入库 */
    materialStatus!: number | undefined;
    /** 物料材质 */
    materialStuff!: string | undefined;
    /** 物料类型名称 */
    materialTypeName!: string | undefined;
    /** 物料计量单位 */
    materialUnit!: string | undefined;
    /** 所属入库单id */
    orderId!: string | undefined;
    /** 物料价格 */
    price!: number | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 实收数量 */
    stockInNum!: number | undefined;
    /** 出库数量 */
    stockOutNum!: number | undefined;
    /** 供应商Id */
    supplierId!: string | undefined;
    /** 检验结果：0-失败，1-成功 */
    testResult!: number | undefined;
    /** 应收数量 */
    totalNum!: number | undefined;

    constructor(data?: IStockInOrderMaterialVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.areaName = data["areaName"];
            this.batchCode = data["batchCode"];
            this.contentType = data["contentType"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.fileName = data["fileName"];
            this.fileObjectKey = data["fileObjectKey"];
            this.id = data["id"];
            this.isMustCheck = data["isMustCheck"];
            this.isRead = data["isRead"];
            this.locationId = data["locationId"];
            this.locationName = data["locationName"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.materialStandardModel = data["materialStandardModel"];
            this.materialStatus = data["materialStatus"];
            this.materialStuff = data["materialStuff"];
            this.materialTypeName = data["materialTypeName"];
            this.materialUnit = data["materialUnit"];
            this.orderId = data["orderId"];
            this.price = data["price"];
            this.remark = data["remark"];
            this.stockInNum = data["stockInNum"];
            this.stockOutNum = data["stockOutNum"];
            this.supplierId = data["supplierId"];
            this.testResult = data["testResult"];
            this.totalNum = data["totalNum"];
        }
    }

    static fromJS(data: any): StockInOrderMaterialVo {
        data = typeof data === 'object' ? data : {};
        let result = new StockInOrderMaterialVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["batchCode"] = this.batchCode;
        data["contentType"] = this.contentType;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["fileName"] = this.fileName;
        data["fileObjectKey"] = this.fileObjectKey;
        data["id"] = this.id;
        data["isMustCheck"] = this.isMustCheck;
        data["isRead"] = this.isRead;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialStandardModel"] = this.materialStandardModel;
        data["materialStatus"] = this.materialStatus;
        data["materialStuff"] = this.materialStuff;
        data["materialTypeName"] = this.materialTypeName;
        data["materialUnit"] = this.materialUnit;
        data["orderId"] = this.orderId;
        data["price"] = this.price;
        data["remark"] = this.remark;
        data["stockInNum"] = this.stockInNum;
        data["stockOutNum"] = this.stockOutNum;
        data["supplierId"] = this.supplierId;
        data["testResult"] = this.testResult;
        data["totalNum"] = this.totalNum;
        return data; 
    }
}

export interface IStockInOrderMaterialVo {
    /** 所属库区Id */
    areaId: string | undefined;
    /** 所属库区名称 */
    areaName: string | undefined;
    /** 物料批号 */
    batchCode: string | undefined;
    /** 文件mini类型 */
    contentType: string | undefined;
    /** 自定义字段1 */
    extend1: string | undefined;
    /** 自定义字段2 */
    extend2: string | undefined;
    /** 自定义字段3 */
    extend3: string | undefined;
    /** 自定义字段4 */
    extend4: string | undefined;
    /** 自定义字段5 */
    extend5: string | undefined;
    /** 检测文件名 */
    fileName: string | undefined;
    /** 文件key */
    fileObjectKey: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否必检：0-非必检，1-必检 */
    isMustCheck: number | undefined;
    /** 是否可以查看质检单 */
    isRead: boolean | undefined;
    /** 所属库区Id */
    locationId: string | undefined;
    /** 所属库区名称 */
    locationName: string | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 所属物料Id */
    materialId: string;
    /** 物料名称 */
    materialName: string | undefined;
    /** 物料规格 */
    materialStandardModel: string | undefined;
    /** 入库状态：0-未入库，1-已入库 */
    materialStatus: number | undefined;
    /** 物料材质 */
    materialStuff: string | undefined;
    /** 物料类型名称 */
    materialTypeName: string | undefined;
    /** 物料计量单位 */
    materialUnit: string | undefined;
    /** 所属入库单id */
    orderId: string | undefined;
    /** 物料价格 */
    price: number | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 实收数量 */
    stockInNum: number | undefined;
    /** 出库数量 */
    stockOutNum: number | undefined;
    /** 供应商Id */
    supplierId: string | undefined;
    /** 检验结果：0-失败，1-成功 */
    testResult: number | undefined;
    /** 应收数量 */
    totalNum: number | undefined;
}

export class StockInOrderVo implements IStockInOrderVo {
    /** 库区ID */
    areaId!: string | undefined;
    /** 送料单号 */
    deliveryCode!: string | undefined;
    /** 送料人员 */
    deliveryUser!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否关联计划：0-不关联，1-关联 */
    isPlan!: string | undefined;
    /** 入库单编号 */
    orderCode!: string | undefined;
    /** 入库单名称 */
    orderName!: string | undefined;
    /** 入库单状态 */
    orderStatus!: number | undefined;
    /** 出库单号 */
    outOrderCode!: string | undefined;
    /** 计划单号 */
    planCode!: string | undefined;
    /** 关联计划id */
    planId!: string | undefined;
    /** 收料单号 */
    receivingCode!: string | undefined;
    /** 收料部门id */
    receivingDept!: string | undefined;
    /** 收料时间 */
    receivingTime!: Date | undefined;
    /** 收料人员id */
    receivingUser!: string | undefined;
    stockInOrderMaterialVoList!: StockInOrderMaterialVo[] | undefined;
    /** 入库类型id */
    stockInTypeId!: string | undefined;
    /** 入库类型名称 */
    stockInTypeName!: string | undefined;
    /** 出库计划编码 */
    stockOutPlanCode!: string | undefined;
    /** 出库计划Id */
    stockOutPlanId!: string | undefined;
    /** 供应商Id */
    supplierId!: string | undefined;

    constructor(data?: IStockInOrderVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.deliveryCode = data["deliveryCode"];
            this.deliveryUser = data["deliveryUser"];
            this.id = data["id"];
            this.isPlan = data["isPlan"];
            this.orderCode = data["orderCode"];
            this.orderName = data["orderName"];
            this.orderStatus = data["orderStatus"];
            this.outOrderCode = data["outOrderCode"];
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.receivingCode = data["receivingCode"];
            this.receivingDept = data["receivingDept"];
            this.receivingTime = data["receivingTime"] ? new Date(data["receivingTime"].toString()) : <any>undefined;
            this.receivingUser = data["receivingUser"];
            if (data["stockInOrderMaterialVoList"] && data["stockInOrderMaterialVoList"].constructor === Array) {
                this.stockInOrderMaterialVoList = [] as any;
                for (let item of data["stockInOrderMaterialVoList"])
                    this.stockInOrderMaterialVoList!.push(StockInOrderMaterialVo.fromJS(item));
            }
            this.stockInTypeId = data["stockInTypeId"];
            this.stockInTypeName = data["stockInTypeName"];
            this.stockOutPlanCode = data["stockOutPlanCode"];
            this.stockOutPlanId = data["stockOutPlanId"];
            this.supplierId = data["supplierId"];
        }
    }

    static fromJS(data: any): StockInOrderVo {
        data = typeof data === 'object' ? data : {};
        let result = new StockInOrderVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["deliveryCode"] = this.deliveryCode;
        data["deliveryUser"] = this.deliveryUser;
        data["id"] = this.id;
        data["isPlan"] = this.isPlan;
        data["orderCode"] = this.orderCode;
        data["orderName"] = this.orderName;
        data["orderStatus"] = this.orderStatus;
        data["outOrderCode"] = this.outOrderCode;
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["receivingCode"] = this.receivingCode;
        data["receivingDept"] = this.receivingDept;
        data["receivingTime"] = this.receivingTime ? this.receivingTime.toISOString() : <any>undefined;
        data["receivingUser"] = this.receivingUser;
        if (this.stockInOrderMaterialVoList && this.stockInOrderMaterialVoList.constructor === Array) {
            data["stockInOrderMaterialVoList"] = [];
            for (let item of this.stockInOrderMaterialVoList)
                data["stockInOrderMaterialVoList"].push(item.toJSON());
        }
        data["stockInTypeId"] = this.stockInTypeId;
        data["stockInTypeName"] = this.stockInTypeName;
        data["stockOutPlanCode"] = this.stockOutPlanCode;
        data["stockOutPlanId"] = this.stockOutPlanId;
        data["supplierId"] = this.supplierId;
        return data; 
    }
}

export interface IStockInOrderVo {
    /** 库区ID */
    areaId: string | undefined;
    /** 送料单号 */
    deliveryCode: string | undefined;
    /** 送料人员 */
    deliveryUser: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否关联计划：0-不关联，1-关联 */
    isPlan: string | undefined;
    /** 入库单编号 */
    orderCode: string | undefined;
    /** 入库单名称 */
    orderName: string | undefined;
    /** 入库单状态 */
    orderStatus: number | undefined;
    /** 出库单号 */
    outOrderCode: string | undefined;
    /** 计划单号 */
    planCode: string | undefined;
    /** 关联计划id */
    planId: string | undefined;
    /** 收料单号 */
    receivingCode: string | undefined;
    /** 收料部门id */
    receivingDept: string | undefined;
    /** 收料时间 */
    receivingTime: Date | undefined;
    /** 收料人员id */
    receivingUser: string | undefined;
    stockInOrderMaterialVoList: StockInOrderMaterialVo[] | undefined;
    /** 入库类型id */
    stockInTypeId: string | undefined;
    /** 入库类型名称 */
    stockInTypeName: string | undefined;
    /** 出库计划编码 */
    stockOutPlanCode: string | undefined;
    /** 出库计划Id */
    stockOutPlanId: string | undefined;
    /** 供应商Id */
    supplierId: string | undefined;
}

export class StockInTypeAddDTO implements IStockInTypeAddDTO {
    /** 入库类型编码 */
    code!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 入库类型名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IStockInTypeAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): StockInTypeAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockInTypeAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IStockInTypeAddDTO {
    /** 入库类型编码 */
    code: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 入库类型名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
}

export class StockInTypeAddOpenApiDTO implements IStockInTypeAddOpenApiDTO {
    /** 入库类型编码 */
    code!: string;
    /** 入库类型名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IStockInTypeAddOpenApiDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): StockInTypeAddOpenApiDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockInTypeAddOpenApiDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IStockInTypeAddOpenApiDTO {
    /** 入库类型编码 */
    code: string;
    /** 入库类型名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
}

export class StockInTypeUpdateDTO implements IStockInTypeUpdateDTO {
    /** 入库类型编码 */
    code!: string;
    /** 入库类型Id */
    id!: string;
    /** 入库类型名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IStockInTypeUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): StockInTypeUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockInTypeUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IStockInTypeUpdateDTO {
    /** 入库类型编码 */
    code: string;
    /** 入库类型Id */
    id: string;
    /** 入库类型名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
}

export class StockInTypeUpdateOpenApiDTO implements IStockInTypeUpdateOpenApiDTO {
    /** 入库类型Id */
    id!: string;
    /** 入库类型名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IStockInTypeUpdateOpenApiDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): StockInTypeUpdateOpenApiDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockInTypeUpdateOpenApiDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IStockInTypeUpdateOpenApiDTO {
    /** 入库类型Id */
    id: string;
    /** 入库类型名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
}

export class StockInTypeVo implements IStockInTypeVo {
    /** 入库类型编码 */
    code!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 入库类型名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IStockInTypeVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): StockInTypeVo {
        data = typeof data === 'object' ? data : {};
        let result = new StockInTypeVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IStockInTypeVo {
    /** 入库类型编码 */
    code: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 入库类型名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

/** 出库单物料信息 */
export class StockOutOrderMaterialDTO implements IStockOutOrderMaterialDTO {
    /** 所属库区id */
    areaId!: string;
    /** 所属库区名 */
    areaName!: string;
    /** 所属库位id */
    locationId!: string;
    /** 所属库位名 */
    locationName!: string;
    /** 物料编号 */
    materialCode!: string;
    /** 所属物料id */
    materialId!: string;
    /** 物料名称 */
    materialName!: string;
    /** 规格 */
    materialStandardModel!: string | undefined;
    /** 材质 */
    materialStuff!: string | undefined;
    /** 所属物料类型名称 */
    materialTypeName!: string;
    /** 计量单位 */
    materialUnit!: string | undefined;
    /** 仅针对关联了计划且出库类型不是订单发运以及在制品出库的情况下要传 */
    planMaterialId!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 库存数量 */
    stockNum!: number;
    /** 出库数量 */
    stockOutNum!: number;

    constructor(data?: IStockOutOrderMaterialDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.areaName = data["areaName"];
            this.locationId = data["locationId"];
            this.locationName = data["locationName"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.materialStandardModel = data["materialStandardModel"];
            this.materialStuff = data["materialStuff"];
            this.materialTypeName = data["materialTypeName"];
            this.materialUnit = data["materialUnit"];
            this.planMaterialId = data["planMaterialId"];
            this.remark = data["remark"];
            this.stockNum = data["stockNum"];
            this.stockOutNum = data["stockOutNum"];
        }
    }

    static fromJS(data: any): StockOutOrderMaterialDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutOrderMaterialDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialStandardModel"] = this.materialStandardModel;
        data["materialStuff"] = this.materialStuff;
        data["materialTypeName"] = this.materialTypeName;
        data["materialUnit"] = this.materialUnit;
        data["planMaterialId"] = this.planMaterialId;
        data["remark"] = this.remark;
        data["stockNum"] = this.stockNum;
        data["stockOutNum"] = this.stockOutNum;
        return data; 
    }
}

/** 出库单物料信息 */
export interface IStockOutOrderMaterialDTO {
    /** 所属库区id */
    areaId: string;
    /** 所属库区名 */
    areaName: string;
    /** 所属库位id */
    locationId: string;
    /** 所属库位名 */
    locationName: string;
    /** 物料编号 */
    materialCode: string;
    /** 所属物料id */
    materialId: string;
    /** 物料名称 */
    materialName: string;
    /** 规格 */
    materialStandardModel: string | undefined;
    /** 材质 */
    materialStuff: string | undefined;
    /** 所属物料类型名称 */
    materialTypeName: string;
    /** 计量单位 */
    materialUnit: string | undefined;
    /** 仅针对关联了计划且出库类型不是订单发运以及在制品出库的情况下要传 */
    planMaterialId: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 库存数量 */
    stockNum: number;
    /** 出库数量 */
    stockOutNum: number;
}

/** 出库单物料信息 */
export class StockOutOrderMaterialTpmVO implements IStockOutOrderMaterialTpmVO {
    /** 库区名称 */
    areaName!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 是否出库 : 0 是  1 否  2 空 */
    issue!: number | undefined;
    /** 库位名称 */
    locationName!: string | undefined;
    /** 库位数量 */
    locationNum!: number | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 所属物料id */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 物料类型 */
    materialType!: string | undefined;
    /** 出库单号 */
    orderCode!: string | undefined;
    /** 所属出库单id */
    orderId!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 退库数量 */
    returnNum!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 出库数量 */
    stockOutNum!: number | undefined;
    /** 总库存数量 */
    stockSumNum!: number | undefined;
    /** 计量单位 */
    unit!: string | undefined;

    constructor(data?: IStockOutOrderMaterialTpmVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaName = data["areaName"];
            this.id = data["id"];
            this.issue = data["issue"];
            this.locationName = data["locationName"];
            this.locationNum = data["locationNum"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.materialType = data["materialType"];
            this.orderCode = data["orderCode"];
            this.orderId = data["orderId"];
            this.remark = data["remark"];
            this.returnNum = data["returnNum"];
            this.standardModel = data["standardModel"];
            this.stockOutNum = data["stockOutNum"];
            this.stockSumNum = data["stockSumNum"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): StockOutOrderMaterialTpmVO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutOrderMaterialTpmVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        data["id"] = this.id;
        data["issue"] = this.issue;
        data["locationName"] = this.locationName;
        data["locationNum"] = this.locationNum;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialType"] = this.materialType;
        data["orderCode"] = this.orderCode;
        data["orderId"] = this.orderId;
        data["remark"] = this.remark;
        data["returnNum"] = this.returnNum;
        data["standardModel"] = this.standardModel;
        data["stockOutNum"] = this.stockOutNum;
        data["stockSumNum"] = this.stockSumNum;
        data["unit"] = this.unit;
        return data; 
    }
}

/** 出库单物料信息 */
export interface IStockOutOrderMaterialTpmVO {
    /** 库区名称 */
    areaName: string | undefined;
    /** id */
    id: string | undefined;
    /** 是否出库 : 0 是  1 否  2 空 */
    issue: number | undefined;
    /** 库位名称 */
    locationName: string | undefined;
    /** 库位数量 */
    locationNum: number | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 所属物料id */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 物料类型 */
    materialType: string | undefined;
    /** 出库单号 */
    orderCode: string | undefined;
    /** 所属出库单id */
    orderId: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 退库数量 */
    returnNum: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 出库数量 */
    stockOutNum: number | undefined;
    /** 总库存数量 */
    stockSumNum: number | undefined;
    /** 计量单位 */
    unit: string | undefined;
}

/** 出库单物料信息 */
export class StockOutOrderMaterialVO implements IStockOutOrderMaterialVO {
    /** 库区名称 */
    areaName!: string | undefined;
    /** 自定义字段1 */
    extend1!: string | undefined;
    /** 自定义字段2 */
    extend2!: string | undefined;
    /** 自定义字段3 */
    extend3!: string | undefined;
    /** 自定义字段4 */
    extend4!: string | undefined;
    /** 自定义字段5 */
    extend5!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 库位名称 */
    locationName!: string | undefined;
    /** 物料编号 */
    materialCode!: string | undefined;
    /** 所属物料id */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    materialStuff!: string | undefined;
    /** 物料类型 */
    materialType!: string | undefined;
    /** 所属出库单id */
    orderId!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 退库数量 */
    returnNum!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 库存数量 */
    stockNum!: number | undefined;
    /** 出库数量 */
    stockOutNum!: number | undefined;
    /** 计量单位 */
    unit!: string | undefined;

    constructor(data?: IStockOutOrderMaterialVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaName = data["areaName"];
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.id = data["id"];
            this.locationName = data["locationName"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.materialStuff = data["materialStuff"];
            this.materialType = data["materialType"];
            this.orderId = data["orderId"];
            this.remark = data["remark"];
            this.returnNum = data["returnNum"];
            this.standardModel = data["standardModel"];
            this.stockNum = data["stockNum"];
            this.stockOutNum = data["stockOutNum"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): StockOutOrderMaterialVO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutOrderMaterialVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["id"] = this.id;
        data["locationName"] = this.locationName;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialStuff"] = this.materialStuff;
        data["materialType"] = this.materialType;
        data["orderId"] = this.orderId;
        data["remark"] = this.remark;
        data["returnNum"] = this.returnNum;
        data["standardModel"] = this.standardModel;
        data["stockNum"] = this.stockNum;
        data["stockOutNum"] = this.stockOutNum;
        data["unit"] = this.unit;
        return data; 
    }
}

/** 出库单物料信息 */
export interface IStockOutOrderMaterialVO {
    /** 库区名称 */
    areaName: string | undefined;
    /** 自定义字段1 */
    extend1: string | undefined;
    /** 自定义字段2 */
    extend2: string | undefined;
    /** 自定义字段3 */
    extend3: string | undefined;
    /** 自定义字段4 */
    extend4: string | undefined;
    /** 自定义字段5 */
    extend5: string | undefined;
    /** id */
    id: string | undefined;
    /** 库位名称 */
    locationName: string | undefined;
    /** 物料编号 */
    materialCode: string | undefined;
    /** 所属物料id */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    materialStuff: string | undefined;
    /** 物料类型 */
    materialType: string | undefined;
    /** 所属出库单id */
    orderId: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 退库数量 */
    returnNum: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 库存数量 */
    stockNum: number | undefined;
    /** 出库数量 */
    stockOutNum: number | undefined;
    /** 计量单位 */
    unit: string | undefined;
}

/** 出库单新建信息 */
export class StockOutOrderSubmitDTO implements IStockOutOrderSubmitDTO {
    /** 数据来源（1：维修；2：保养） */
    bizType!: number | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 客户id */
    customerId!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 领配人员id */
    distributeUser!: string | undefined;
    /** 领配人员名称 */
    distributeUserName!: string | undefined;
    /** 是否关联计划：0-不关联，1-关联 */
    isPlan!: string;
    /** 出库物料 */
    list!: StockOutOrderMaterialDTO[] | undefined;
    /** 出库单编号 */
    orderCode!: string | undefined;
    /** 出库单名称 */
    orderName!: string | undefined;
    /** 计划单号 */
    planCode!: string | undefined;
    /** 计划id */
    planId!: string | undefined;
    /** 计划订单编号 */
    planOrderCode!: string | undefined;
    /** 工序编码 */
    processCode!: string | undefined;
    /** 工序id */
    processId!: string | undefined;
    /** 工序名称 */
    processName!: string | undefined;
    /** 生产车间，部门id */
    produceDept!: string | undefined;
    /** 生产车间名称 */
    produceDeptName!: string | undefined;
    /** 出库计划编码 */
    stockOutPlanCode!: string | undefined;
    /** 出库计划ID */
    stockOutPlanId!: string | undefined;
    /** 出库时间 */
    stockOutTime!: Date;
    /** 出库类型id */
    stockOutTypeId!: string;
    /** 出库类型名称 */
    stockOutTypeName!: string;
    /** 出库人员id */
    stockOutUser!: string | undefined;
    /** 出库人员名称 */
    stockOutUserName!: string | undefined;
    /** 工单code */
    workOrderCode!: string | undefined;
    /** 工单id */
    workOrderId!: string | undefined;

    constructor(data?: IStockOutOrderSubmitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bizType = data["bizType"];
            this.codeRuleId = data["codeRuleId"];
            this.customerId = data["customerId"];
            this.customerName = data["customerName"];
            this.distributeUser = data["distributeUser"];
            this.distributeUserName = data["distributeUserName"];
            this.isPlan = data["isPlan"];
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(StockOutOrderMaterialDTO.fromJS(item));
            }
            this.orderCode = data["orderCode"];
            this.orderName = data["orderName"];
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.planOrderCode = data["planOrderCode"];
            this.processCode = data["processCode"];
            this.processId = data["processId"];
            this.processName = data["processName"];
            this.produceDept = data["produceDept"];
            this.produceDeptName = data["produceDeptName"];
            this.stockOutPlanCode = data["stockOutPlanCode"];
            this.stockOutPlanId = data["stockOutPlanId"];
            this.stockOutTime = data["stockOutTime"] ? new Date(data["stockOutTime"].toString()) : <any>undefined;
            this.stockOutTypeId = data["stockOutTypeId"];
            this.stockOutTypeName = data["stockOutTypeName"];
            this.stockOutUser = data["stockOutUser"];
            this.stockOutUserName = data["stockOutUserName"];
            this.workOrderCode = data["workOrderCode"];
            this.workOrderId = data["workOrderId"];
        }
    }

    static fromJS(data: any): StockOutOrderSubmitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutOrderSubmitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bizType"] = this.bizType;
        data["codeRuleId"] = this.codeRuleId;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["distributeUser"] = this.distributeUser;
        data["distributeUserName"] = this.distributeUserName;
        data["isPlan"] = this.isPlan;
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["orderCode"] = this.orderCode;
        data["orderName"] = this.orderName;
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["planOrderCode"] = this.planOrderCode;
        data["processCode"] = this.processCode;
        data["processId"] = this.processId;
        data["processName"] = this.processName;
        data["produceDept"] = this.produceDept;
        data["produceDeptName"] = this.produceDeptName;
        data["stockOutPlanCode"] = this.stockOutPlanCode;
        data["stockOutPlanId"] = this.stockOutPlanId;
        data["stockOutTime"] = this.stockOutTime ? this.stockOutTime.toISOString() : <any>undefined;
        data["stockOutTypeId"] = this.stockOutTypeId;
        data["stockOutTypeName"] = this.stockOutTypeName;
        data["stockOutUser"] = this.stockOutUser;
        data["stockOutUserName"] = this.stockOutUserName;
        data["workOrderCode"] = this.workOrderCode;
        data["workOrderId"] = this.workOrderId;
        return data; 
    }
}

/** 出库单新建信息 */
export interface IStockOutOrderSubmitDTO {
    /** 数据来源（1：维修；2：保养） */
    bizType: number | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 客户id */
    customerId: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 领配人员id */
    distributeUser: string | undefined;
    /** 领配人员名称 */
    distributeUserName: string | undefined;
    /** 是否关联计划：0-不关联，1-关联 */
    isPlan: string;
    /** 出库物料 */
    list: StockOutOrderMaterialDTO[] | undefined;
    /** 出库单编号 */
    orderCode: string | undefined;
    /** 出库单名称 */
    orderName: string | undefined;
    /** 计划单号 */
    planCode: string | undefined;
    /** 计划id */
    planId: string | undefined;
    /** 计划订单编号 */
    planOrderCode: string | undefined;
    /** 工序编码 */
    processCode: string | undefined;
    /** 工序id */
    processId: string | undefined;
    /** 工序名称 */
    processName: string | undefined;
    /** 生产车间，部门id */
    produceDept: string | undefined;
    /** 生产车间名称 */
    produceDeptName: string | undefined;
    /** 出库计划编码 */
    stockOutPlanCode: string | undefined;
    /** 出库计划ID */
    stockOutPlanId: string | undefined;
    /** 出库时间 */
    stockOutTime: Date;
    /** 出库类型id */
    stockOutTypeId: string;
    /** 出库类型名称 */
    stockOutTypeName: string;
    /** 出库人员id */
    stockOutUser: string | undefined;
    /** 出库人员名称 */
    stockOutUserName: string | undefined;
    /** 工单code */
    workOrderCode: string | undefined;
    /** 工单id */
    workOrderId: string | undefined;
}

/** 出库单分页信息 */
export class StockOutOrderVO implements IStockOutOrderVO {
    /** 领配人员 */
    distributeUser!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 出库单编号 */
    orderCode!: string | undefined;
    /** 出库单名称 */
    orderName!: string | undefined;
    /** 计划单号 */
    planCode!: string | undefined;
    /** 生产车间 */
    produceDept!: string | undefined;
    /** 出库单下物料 */
    stockOutOrderMaterialVOList!: StockOutOrderMaterialVO[] | undefined;
    /** 出库时间 */
    stockOutTime!: Date | undefined;
    /** 出库类型 */
    stockOutType!: string | undefined;
    /** 出库人员 */
    stockOutUser!: string | undefined;

    constructor(data?: IStockOutOrderVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.distributeUser = data["distributeUser"];
            this.id = data["id"];
            this.orderCode = data["orderCode"];
            this.orderName = data["orderName"];
            this.planCode = data["planCode"];
            this.produceDept = data["produceDept"];
            if (data["stockOutOrderMaterialVOList"] && data["stockOutOrderMaterialVOList"].constructor === Array) {
                this.stockOutOrderMaterialVOList = [] as any;
                for (let item of data["stockOutOrderMaterialVOList"])
                    this.stockOutOrderMaterialVOList!.push(StockOutOrderMaterialVO.fromJS(item));
            }
            this.stockOutTime = data["stockOutTime"] ? new Date(data["stockOutTime"].toString()) : <any>undefined;
            this.stockOutType = data["stockOutType"];
            this.stockOutUser = data["stockOutUser"];
        }
    }

    static fromJS(data: any): StockOutOrderVO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutOrderVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["distributeUser"] = this.distributeUser;
        data["id"] = this.id;
        data["orderCode"] = this.orderCode;
        data["orderName"] = this.orderName;
        data["planCode"] = this.planCode;
        data["produceDept"] = this.produceDept;
        if (this.stockOutOrderMaterialVOList && this.stockOutOrderMaterialVOList.constructor === Array) {
            data["stockOutOrderMaterialVOList"] = [];
            for (let item of this.stockOutOrderMaterialVOList)
                data["stockOutOrderMaterialVOList"].push(item.toJSON());
        }
        data["stockOutTime"] = this.stockOutTime ? this.stockOutTime.toISOString() : <any>undefined;
        data["stockOutType"] = this.stockOutType;
        data["stockOutUser"] = this.stockOutUser;
        return data; 
    }
}

/** 出库单分页信息 */
export interface IStockOutOrderVO {
    /** 领配人员 */
    distributeUser: string | undefined;
    /** id */
    id: string | undefined;
    /** 出库单编号 */
    orderCode: string | undefined;
    /** 出库单名称 */
    orderName: string | undefined;
    /** 计划单号 */
    planCode: string | undefined;
    /** 生产车间 */
    produceDept: string | undefined;
    /** 出库单下物料 */
    stockOutOrderMaterialVOList: StockOutOrderMaterialVO[] | undefined;
    /** 出库时间 */
    stockOutTime: Date | undefined;
    /** 出库类型 */
    stockOutType: string | undefined;
    /** 出库人员 */
    stockOutUser: string | undefined;
}

/** 出库计划新建DTO */
export class StockOutPlanAddDTO implements IStockOutPlanAddDTO {
    /** 所选bom的id */
    bomId!: string | undefined;
    /** 所选bom的版本 */
    bomVersion!: string | undefined;
    /** 出库计划编码 */
    code!: string | undefined;
    /** 所属产品工艺 */
    craftId!: string | undefined;
    /** 产品工艺版本 */
    craftVersion!: string | undefined;
    /** 出库计划物料 */
    list!: StockOutPlanMaterialAddDTO[] | undefined;
    /** 计划单号 */
    planCode!: string | undefined;
    /** 计划id */
    planId!: string | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 计划出库时间 */
    planStockOutTime!: Date | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 出库人员编码 */
    stockOutUserCodeList!: string[] | undefined;
    /** 出库人员id */
    stockOutUserIdList!: string[] | undefined;
    /** 出库人员名称 */
    stockOutUserNameList!: string[] | undefined;

    constructor(data?: IStockOutPlanAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bomId = data["bomId"];
            this.bomVersion = data["bomVersion"];
            this.code = data["code"];
            this.craftId = data["craftId"];
            this.craftVersion = data["craftVersion"];
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(StockOutPlanMaterialAddDTO.fromJS(item));
            }
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.planStockOutTime = data["planStockOutTime"] ? new Date(data["planStockOutTime"].toString()) : <any>undefined;
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.standardModel = data["standardModel"];
            if (data["stockOutUserCodeList"] && data["stockOutUserCodeList"].constructor === Array) {
                this.stockOutUserCodeList = [] as any;
                for (let item of data["stockOutUserCodeList"])
                    this.stockOutUserCodeList!.push(item);
            }
            if (data["stockOutUserIdList"] && data["stockOutUserIdList"].constructor === Array) {
                this.stockOutUserIdList = [] as any;
                for (let item of data["stockOutUserIdList"])
                    this.stockOutUserIdList!.push(item);
            }
            if (data["stockOutUserNameList"] && data["stockOutUserNameList"].constructor === Array) {
                this.stockOutUserNameList = [] as any;
                for (let item of data["stockOutUserNameList"])
                    this.stockOutUserNameList!.push(item);
            }
        }
    }

    static fromJS(data: any): StockOutPlanAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutPlanAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bomId"] = this.bomId;
        data["bomVersion"] = this.bomVersion;
        data["code"] = this.code;
        data["craftId"] = this.craftId;
        data["craftVersion"] = this.craftVersion;
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["planStockOutTime"] = this.planStockOutTime ? this.planStockOutTime.toISOString() : <any>undefined;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["standardModel"] = this.standardModel;
        if (this.stockOutUserCodeList && this.stockOutUserCodeList.constructor === Array) {
            data["stockOutUserCodeList"] = [];
            for (let item of this.stockOutUserCodeList)
                data["stockOutUserCodeList"].push(item);
        }
        if (this.stockOutUserIdList && this.stockOutUserIdList.constructor === Array) {
            data["stockOutUserIdList"] = [];
            for (let item of this.stockOutUserIdList)
                data["stockOutUserIdList"].push(item);
        }
        if (this.stockOutUserNameList && this.stockOutUserNameList.constructor === Array) {
            data["stockOutUserNameList"] = [];
            for (let item of this.stockOutUserNameList)
                data["stockOutUserNameList"].push(item);
        }
        return data; 
    }
}

/** 出库计划新建DTO */
export interface IStockOutPlanAddDTO {
    /** 所选bom的id */
    bomId: string | undefined;
    /** 所选bom的版本 */
    bomVersion: string | undefined;
    /** 出库计划编码 */
    code: string | undefined;
    /** 所属产品工艺 */
    craftId: string | undefined;
    /** 产品工艺版本 */
    craftVersion: string | undefined;
    /** 出库计划物料 */
    list: StockOutPlanMaterialAddDTO[] | undefined;
    /** 计划单号 */
    planCode: string | undefined;
    /** 计划id */
    planId: string | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 计划出库时间 */
    planStockOutTime: Date | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 出库人员编码 */
    stockOutUserCodeList: string[] | undefined;
    /** 出库人员id */
    stockOutUserIdList: string[] | undefined;
    /** 出库人员名称 */
    stockOutUserNameList: string[] | undefined;
}

/** 出库计划编辑DTO */
export class StockOutPlanEditDTO implements IStockOutPlanEditDTO {
    /** 出库计划id */
    id!: string | undefined;
    /** 出库计划物料 */
    list!: StockOutPlanMaterialEditDTO[] | undefined;

    constructor(data?: IStockOutPlanEditDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(StockOutPlanMaterialEditDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StockOutPlanEditDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutPlanEditDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        return data; 
    }
}

/** 出库计划编辑DTO */
export interface IStockOutPlanEditDTO {
    /** 出库计划id */
    id: string | undefined;
    /** 出库计划物料 */
    list: StockOutPlanMaterialEditDTO[] | undefined;
}

/** 出库计划物料新建DTO */
export class StockOutPlanMaterialAddDTO implements IStockOutPlanMaterialAddDTO {
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料id */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 计划物料Id */
    planMaterialId!: string | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 已计划出库数量 */
    plannedNum!: number | undefined;
    /** 需求数量 */
    requireNum!: number | undefined;
    /** 出库计划id */
    stockOutPlanId!: string | undefined;
    /** 待出库数量 */
    toBeDeliveredNum!: number | undefined;

    constructor(data?: IStockOutPlanMaterialAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.planMaterialId = data["planMaterialId"];
            this.planNum = data["planNum"];
            this.plannedNum = data["plannedNum"];
            this.requireNum = data["requireNum"];
            this.stockOutPlanId = data["stockOutPlanId"];
            this.toBeDeliveredNum = data["toBeDeliveredNum"];
        }
    }

    static fromJS(data: any): StockOutPlanMaterialAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutPlanMaterialAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["planMaterialId"] = this.planMaterialId;
        data["planNum"] = this.planNum;
        data["plannedNum"] = this.plannedNum;
        data["requireNum"] = this.requireNum;
        data["stockOutPlanId"] = this.stockOutPlanId;
        data["toBeDeliveredNum"] = this.toBeDeliveredNum;
        return data; 
    }
}

/** 出库计划物料新建DTO */
export interface IStockOutPlanMaterialAddDTO {
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料id */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 计划物料Id */
    planMaterialId: string | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 已计划出库数量 */
    plannedNum: number | undefined;
    /** 需求数量 */
    requireNum: number | undefined;
    /** 出库计划id */
    stockOutPlanId: string | undefined;
    /** 待出库数量 */
    toBeDeliveredNum: number | undefined;
}

/** 出库计划物料编辑DTO */
export class StockOutPlanMaterialEditDTO implements IStockOutPlanMaterialEditDTO {
    /** 已出库数量 */
    deliveredNum!: number | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料id */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 计划物料Id */
    planMaterialId!: string | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 已计划出库数量 */
    plannedNum!: number | undefined;
    /** 已出库数量 */
    requireNum!: number | undefined;
    /** 出库计划id */
    stockOutPlanId!: string | undefined;
    /** 待出库数量 */
    toBeDeliveredNum!: number | undefined;

    constructor(data?: IStockOutPlanMaterialEditDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deliveredNum = data["deliveredNum"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.planMaterialId = data["planMaterialId"];
            this.planNum = data["planNum"];
            this.plannedNum = data["plannedNum"];
            this.requireNum = data["requireNum"];
            this.stockOutPlanId = data["stockOutPlanId"];
            this.toBeDeliveredNum = data["toBeDeliveredNum"];
        }
    }

    static fromJS(data: any): StockOutPlanMaterialEditDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutPlanMaterialEditDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveredNum"] = this.deliveredNum;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["planMaterialId"] = this.planMaterialId;
        data["planNum"] = this.planNum;
        data["plannedNum"] = this.plannedNum;
        data["requireNum"] = this.requireNum;
        data["stockOutPlanId"] = this.stockOutPlanId;
        data["toBeDeliveredNum"] = this.toBeDeliveredNum;
        return data; 
    }
}

/** 出库计划物料编辑DTO */
export interface IStockOutPlanMaterialEditDTO {
    /** 已出库数量 */
    deliveredNum: number | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料id */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 计划物料Id */
    planMaterialId: string | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 已计划出库数量 */
    plannedNum: number | undefined;
    /** 已出库数量 */
    requireNum: number | undefined;
    /** 出库计划id */
    stockOutPlanId: string | undefined;
    /** 待出库数量 */
    toBeDeliveredNum: number | undefined;
}

/** 出库计划选择物料信息 */
export class StockOutPlanMaterialSelectionVO implements IStockOutPlanMaterialSelectionVO {
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料ID */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 计划物料ID */
    planMaterialId!: string | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 已计划出库数量 */
    plannedNum!: number | undefined;
    /** 需求数量 */
    requireNum!: number | undefined;
    /** 库存总量 */
    totalNum!: number | undefined;

    constructor(data?: IStockOutPlanMaterialSelectionVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.planMaterialId = data["planMaterialId"];
            this.planNum = data["planNum"];
            this.plannedNum = data["plannedNum"];
            this.requireNum = data["requireNum"];
            this.totalNum = data["totalNum"];
        }
    }

    static fromJS(data: any): StockOutPlanMaterialSelectionVO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutPlanMaterialSelectionVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["planMaterialId"] = this.planMaterialId;
        data["planNum"] = this.planNum;
        data["plannedNum"] = this.plannedNum;
        data["requireNum"] = this.requireNum;
        data["totalNum"] = this.totalNum;
        return data; 
    }
}

/** 出库计划选择物料信息 */
export interface IStockOutPlanMaterialSelectionVO {
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料ID */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 计划物料ID */
    planMaterialId: string | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 已计划出库数量 */
    plannedNum: number | undefined;
    /** 需求数量 */
    requireNum: number | undefined;
    /** 库存总量 */
    totalNum: number | undefined;
}

/** 出库计划物料 */
export class StockOutPlanMaterialVO implements IStockOutPlanMaterialVO {
    /** 已出库数量 */
    deliveredNum!: number | undefined;
    /** id */
    id!: string | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 物料id */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 物料规格 */
    materialStandardModel!: string | undefined;
    /** 物料材质 */
    materialStuff!: string | undefined;
    /** 物料类型 */
    materialTypeName!: string | undefined;
    /** 物料计量单位 */
    materialUnit!: string | undefined;
    /** 计划物料ID */
    planMaterialId!: string | undefined;
    /** 计划数量 */
    planNum!: number | undefined;
    /** 已计划出库数量 */
    plannedNum!: number | undefined;
    /** 需求数量 */
    requireNum!: number | undefined;
    /** 出库计划id */
    stockOutPlanId!: string | undefined;
    /** 待出库数量 */
    toBeDeliveredNum!: number | undefined;
    /** 库存总量 */
    totalNum!: number | undefined;

    constructor(data?: IStockOutPlanMaterialVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deliveredNum = data["deliveredNum"];
            this.id = data["id"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.materialStandardModel = data["materialStandardModel"];
            this.materialStuff = data["materialStuff"];
            this.materialTypeName = data["materialTypeName"];
            this.materialUnit = data["materialUnit"];
            this.planMaterialId = data["planMaterialId"];
            this.planNum = data["planNum"];
            this.plannedNum = data["plannedNum"];
            this.requireNum = data["requireNum"];
            this.stockOutPlanId = data["stockOutPlanId"];
            this.toBeDeliveredNum = data["toBeDeliveredNum"];
            this.totalNum = data["totalNum"];
        }
    }

    static fromJS(data: any): StockOutPlanMaterialVO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutPlanMaterialVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deliveredNum"] = this.deliveredNum;
        data["id"] = this.id;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialStandardModel"] = this.materialStandardModel;
        data["materialStuff"] = this.materialStuff;
        data["materialTypeName"] = this.materialTypeName;
        data["materialUnit"] = this.materialUnit;
        data["planMaterialId"] = this.planMaterialId;
        data["planNum"] = this.planNum;
        data["plannedNum"] = this.plannedNum;
        data["requireNum"] = this.requireNum;
        data["stockOutPlanId"] = this.stockOutPlanId;
        data["toBeDeliveredNum"] = this.toBeDeliveredNum;
        data["totalNum"] = this.totalNum;
        return data; 
    }
}

/** 出库计划物料 */
export interface IStockOutPlanMaterialVO {
    /** 已出库数量 */
    deliveredNum: number | undefined;
    /** id */
    id: string | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 物料id */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 物料规格 */
    materialStandardModel: string | undefined;
    /** 物料材质 */
    materialStuff: string | undefined;
    /** 物料类型 */
    materialTypeName: string | undefined;
    /** 物料计量单位 */
    materialUnit: string | undefined;
    /** 计划物料ID */
    planMaterialId: string | undefined;
    /** 计划数量 */
    planNum: number | undefined;
    /** 已计划出库数量 */
    plannedNum: number | undefined;
    /** 需求数量 */
    requireNum: number | undefined;
    /** 出库计划id */
    stockOutPlanId: string | undefined;
    /** 待出库数量 */
    toBeDeliveredNum: number | undefined;
    /** 库存总量 */
    totalNum: number | undefined;
}

/** 出库单物料信息 */
export class StockOutPlanStockOutMaterialDTO implements IStockOutPlanStockOutMaterialDTO {
    /** 所属库区id */
    areaId!: string;
    /** 所属库区名 */
    areaName!: string;
    /** 所属库位id */
    locationId!: string;
    /** 所属库位名 */
    locationName!: string;
    /** 物料编号 */
    materialCode!: string;
    /** 所属物料id */
    materialId!: string;
    /** 物料名称 */
    materialName!: string;
    /** 计划物料ID */
    planMaterialId!: string;
    /** 库存数量 */
    stockNum!: number;
    /** 出库数量 */
    stockOutNum!: number;

    constructor(data?: IStockOutPlanStockOutMaterialDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaId = data["areaId"];
            this.areaName = data["areaName"];
            this.locationId = data["locationId"];
            this.locationName = data["locationName"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.planMaterialId = data["planMaterialId"];
            this.stockNum = data["stockNum"];
            this.stockOutNum = data["stockOutNum"];
        }
    }

    static fromJS(data: any): StockOutPlanStockOutMaterialDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutPlanStockOutMaterialDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["planMaterialId"] = this.planMaterialId;
        data["stockNum"] = this.stockNum;
        data["stockOutNum"] = this.stockOutNum;
        return data; 
    }
}

/** 出库单物料信息 */
export interface IStockOutPlanStockOutMaterialDTO {
    /** 所属库区id */
    areaId: string;
    /** 所属库区名 */
    areaName: string;
    /** 所属库位id */
    locationId: string;
    /** 所属库位名 */
    locationName: string;
    /** 物料编号 */
    materialCode: string;
    /** 所属物料id */
    materialId: string;
    /** 物料名称 */
    materialName: string;
    /** 计划物料ID */
    planMaterialId: string;
    /** 库存数量 */
    stockNum: number;
    /** 出库数量 */
    stockOutNum: number;
}

/** 出库计划出库单提交DTO */
export class StockOutPlanStockOutSubmitDTO implements IStockOutPlanStockOutSubmitDTO {
    /** 出库物料 */
    list!: StockOutPlanStockOutMaterialDTO[] | undefined;
    /** 领料人员编码 */
    pickingUserId!: string | undefined;
    /** 计划单号 */
    planCode!: string | undefined;
    /** 计划id */
    planId!: string | undefined;
    /** 出库计划号 */
    stockOutPlanCode!: string | undefined;
    /** 出库计划Id */
    stockOutPlanId!: string | undefined;
    /** 出库人员 */
    stockOutUserId!: string | undefined;

    constructor(data?: IStockOutPlanStockOutSubmitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(StockOutPlanStockOutMaterialDTO.fromJS(item));
            }
            this.pickingUserId = data["pickingUserId"];
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.stockOutPlanCode = data["stockOutPlanCode"];
            this.stockOutPlanId = data["stockOutPlanId"];
            this.stockOutUserId = data["stockOutUserId"];
        }
    }

    static fromJS(data: any): StockOutPlanStockOutSubmitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutPlanStockOutSubmitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["pickingUserId"] = this.pickingUserId;
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["stockOutPlanCode"] = this.stockOutPlanCode;
        data["stockOutPlanId"] = this.stockOutPlanId;
        data["stockOutUserId"] = this.stockOutUserId;
        return data; 
    }
}

/** 出库计划出库单提交DTO */
export interface IStockOutPlanStockOutSubmitDTO {
    /** 出库物料 */
    list: StockOutPlanStockOutMaterialDTO[] | undefined;
    /** 领料人员编码 */
    pickingUserId: string | undefined;
    /** 计划单号 */
    planCode: string | undefined;
    /** 计划id */
    planId: string | undefined;
    /** 出库计划号 */
    stockOutPlanCode: string | undefined;
    /** 出库计划Id */
    stockOutPlanId: string | undefined;
    /** 出库人员 */
    stockOutUserId: string | undefined;
}

/** 出库计划信息 */
export class StockOutPlanVO implements IStockOutPlanVO {
    /** 所选bom的id */
    bomId!: string | undefined;
    /** 所选bom的版本 */
    bomVersion!: string | undefined;
    /** 出库计划单号 */
    code!: string | undefined;
    /** 所属产品工艺 */
    craftId!: string | undefined;
    /** 产品工艺版本 */
    craftVersion!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 计划单号 */
    planCode!: string | undefined;
    /** 计划id */
    planId!: string | undefined;
    /** 计划开始时间 */
    planStartTime!: Date | undefined;
    /** 出库计划状态(1:待出库;2:未完成;3:已完成) */
    planStatus!: number | undefined;
    /** 计划状态名称 */
    planStatusName!: string | undefined;
    /** 计划出库时间 */
    planStockOutTime!: Date | undefined;
    /** 产品编号 */
    productCode!: string | undefined;
    /** 产品名称 */
    productName!: string | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    stockOutPlanMaterialList!: StockOutPlanMaterialVO[] | undefined;
    /** 出库人员编码 */
    stockOutUserCode!: string | undefined;
    /** 出库人员id */
    stockOutUserId!: string | undefined;
    /** 出库人员名称 */
    stockOutUserName!: string | undefined;

    constructor(data?: IStockOutPlanVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bomId = data["bomId"];
            this.bomVersion = data["bomVersion"];
            this.code = data["code"];
            this.craftId = data["craftId"];
            this.craftVersion = data["craftVersion"];
            this.id = data["id"];
            this.planCode = data["planCode"];
            this.planId = data["planId"];
            this.planStartTime = data["planStartTime"] ? new Date(data["planStartTime"].toString()) : <any>undefined;
            this.planStatus = data["planStatus"];
            this.planStatusName = data["planStatusName"];
            this.planStockOutTime = data["planStockOutTime"] ? new Date(data["planStockOutTime"].toString()) : <any>undefined;
            this.productCode = data["productCode"];
            this.productName = data["productName"];
            this.standardModel = data["standardModel"];
            if (data["stockOutPlanMaterialList"] && data["stockOutPlanMaterialList"].constructor === Array) {
                this.stockOutPlanMaterialList = [] as any;
                for (let item of data["stockOutPlanMaterialList"])
                    this.stockOutPlanMaterialList!.push(StockOutPlanMaterialVO.fromJS(item));
            }
            this.stockOutUserCode = data["stockOutUserCode"];
            this.stockOutUserId = data["stockOutUserId"];
            this.stockOutUserName = data["stockOutUserName"];
        }
    }

    static fromJS(data: any): StockOutPlanVO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutPlanVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bomId"] = this.bomId;
        data["bomVersion"] = this.bomVersion;
        data["code"] = this.code;
        data["craftId"] = this.craftId;
        data["craftVersion"] = this.craftVersion;
        data["id"] = this.id;
        data["planCode"] = this.planCode;
        data["planId"] = this.planId;
        data["planStartTime"] = this.planStartTime ? this.planStartTime.toISOString() : <any>undefined;
        data["planStatus"] = this.planStatus;
        data["planStatusName"] = this.planStatusName;
        data["planStockOutTime"] = this.planStockOutTime ? this.planStockOutTime.toISOString() : <any>undefined;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["standardModel"] = this.standardModel;
        if (this.stockOutPlanMaterialList && this.stockOutPlanMaterialList.constructor === Array) {
            data["stockOutPlanMaterialList"] = [];
            for (let item of this.stockOutPlanMaterialList)
                data["stockOutPlanMaterialList"].push(item.toJSON());
        }
        data["stockOutUserCode"] = this.stockOutUserCode;
        data["stockOutUserId"] = this.stockOutUserId;
        data["stockOutUserName"] = this.stockOutUserName;
        return data; 
    }
}

/** 出库计划信息 */
export interface IStockOutPlanVO {
    /** 所选bom的id */
    bomId: string | undefined;
    /** 所选bom的版本 */
    bomVersion: string | undefined;
    /** 出库计划单号 */
    code: string | undefined;
    /** 所属产品工艺 */
    craftId: string | undefined;
    /** 产品工艺版本 */
    craftVersion: string | undefined;
    /** id */
    id: string | undefined;
    /** 计划单号 */
    planCode: string | undefined;
    /** 计划id */
    planId: string | undefined;
    /** 计划开始时间 */
    planStartTime: Date | undefined;
    /** 出库计划状态(1:待出库;2:未完成;3:已完成) */
    planStatus: number | undefined;
    /** 计划状态名称 */
    planStatusName: string | undefined;
    /** 计划出库时间 */
    planStockOutTime: Date | undefined;
    /** 产品编号 */
    productCode: string | undefined;
    /** 产品名称 */
    productName: string | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    stockOutPlanMaterialList: StockOutPlanMaterialVO[] | undefined;
    /** 出库人员编码 */
    stockOutUserCode: string | undefined;
    /** 出库人员id */
    stockOutUserId: string | undefined;
    /** 出库人员名称 */
    stockOutUserName: string | undefined;
}

export class StockOutTypeAddDTO implements IStockOutTypeAddDTO {
    /** 出库类型编码 */
    code!: string | undefined;
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 出库类型名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IStockOutTypeAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.codeRuleId = data["codeRuleId"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): StockOutTypeAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutTypeAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["codeRuleId"] = this.codeRuleId;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IStockOutTypeAddDTO {
    /** 出库类型编码 */
    code: string | undefined;
    /** 规则id */
    codeRuleId: string | undefined;
    /** 出库类型名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
}

export class StockOutTypeAddOpenApiDTO implements IStockOutTypeAddOpenApiDTO {
    /** 出库类型编码 */
    code!: string;
    /** 出库类型名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IStockOutTypeAddOpenApiDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): StockOutTypeAddOpenApiDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutTypeAddOpenApiDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IStockOutTypeAddOpenApiDTO {
    /** 出库类型编码 */
    code: string;
    /** 出库类型名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
}

export class StockOutTypeUpdateDTO implements IStockOutTypeUpdateDTO {
    /** 出库类型编码 */
    code!: string;
    /** 出库类型Id */
    id!: string;
    /** 出库类型名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IStockOutTypeUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): StockOutTypeUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutTypeUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IStockOutTypeUpdateDTO {
    /** 出库类型编码 */
    code: string;
    /** 出库类型Id */
    id: string;
    /** 出库类型名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
}

export class StockOutTypeUpdateOpenApiDTO implements IStockOutTypeUpdateOpenApiDTO {
    /** 出库类型Id */
    id!: string;
    /** 出库类型名称 */
    name!: string;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IStockOutTypeUpdateOpenApiDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): StockOutTypeUpdateOpenApiDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutTypeUpdateOpenApiDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IStockOutTypeUpdateOpenApiDTO {
    /** 出库类型Id */
    id: string;
    /** 出库类型名称 */
    name: string;
    /** 备注 */
    remark: string | undefined;
}

export class StockOutTypeVo implements IStockOutTypeVo {
    /** 入库类型编码 */
    code!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 入库类型名称 */
    name!: string | undefined;
    /** 备注 */
    remark!: string | undefined;

    constructor(data?: IStockOutTypeVo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.id = data["id"];
            this.name = data["name"];
            this.remark = data["remark"];
        }
    }

    static fromJS(data: any): StockOutTypeVo {
        data = typeof data === 'object' ? data : {};
        let result = new StockOutTypeVo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        data["name"] = this.name;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IStockOutTypeVo {
    /** 入库类型编码 */
    code: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 入库类型名称 */
    name: string | undefined;
    /** 备注 */
    remark: string | undefined;
}

/** 新建移库单物料 */
export class StockShiftOrderMaterialDTO implements IStockShiftOrderMaterialDTO {
    /** 源库区id */
    fromAreaId!: string | undefined;
    /** 源库区名称 */
    fromAreaName!: string | undefined;
    /** 源库位id */
    fromLocationId!: string | undefined;
    /** 源库位名称 */
    fromLocationName!: string | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 所属物料id */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    /** 规格 */
    materialStandardModel!: string | undefined;
    /** 材质 */
    materialStuff!: string | undefined;
    /** 所属物料类型名称 */
    materialTypeName!: string | undefined;
    /** 计量单位 */
    materialUnit!: string | undefined;
    /** 备注 */
    remark!: string | undefined;
    /** 移库数量 */
    shiftNum!: number | undefined;
    /** 源库存数量 */
    stockNum!: number | undefined;
    /** 目标库区id */
    toAreaId!: string | undefined;
    /** 目标库区名称 */
    toAreaName!: string | undefined;
    /** 目标库位id */
    toLocationId!: string | undefined;
    /** 目标库位名称 */
    toLocationName!: string | undefined;

    constructor(data?: IStockShiftOrderMaterialDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fromAreaId = data["fromAreaId"];
            this.fromAreaName = data["fromAreaName"];
            this.fromLocationId = data["fromLocationId"];
            this.fromLocationName = data["fromLocationName"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.materialStandardModel = data["materialStandardModel"];
            this.materialStuff = data["materialStuff"];
            this.materialTypeName = data["materialTypeName"];
            this.materialUnit = data["materialUnit"];
            this.remark = data["remark"];
            this.shiftNum = data["shiftNum"];
            this.stockNum = data["stockNum"];
            this.toAreaId = data["toAreaId"];
            this.toAreaName = data["toAreaName"];
            this.toLocationId = data["toLocationId"];
            this.toLocationName = data["toLocationName"];
        }
    }

    static fromJS(data: any): StockShiftOrderMaterialDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockShiftOrderMaterialDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromAreaId"] = this.fromAreaId;
        data["fromAreaName"] = this.fromAreaName;
        data["fromLocationId"] = this.fromLocationId;
        data["fromLocationName"] = this.fromLocationName;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialStandardModel"] = this.materialStandardModel;
        data["materialStuff"] = this.materialStuff;
        data["materialTypeName"] = this.materialTypeName;
        data["materialUnit"] = this.materialUnit;
        data["remark"] = this.remark;
        data["shiftNum"] = this.shiftNum;
        data["stockNum"] = this.stockNum;
        data["toAreaId"] = this.toAreaId;
        data["toAreaName"] = this.toAreaName;
        data["toLocationId"] = this.toLocationId;
        data["toLocationName"] = this.toLocationName;
        return data; 
    }
}

/** 新建移库单物料 */
export interface IStockShiftOrderMaterialDTO {
    /** 源库区id */
    fromAreaId: string | undefined;
    /** 源库区名称 */
    fromAreaName: string | undefined;
    /** 源库位id */
    fromLocationId: string | undefined;
    /** 源库位名称 */
    fromLocationName: string | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 所属物料id */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    /** 规格 */
    materialStandardModel: string | undefined;
    /** 材质 */
    materialStuff: string | undefined;
    /** 所属物料类型名称 */
    materialTypeName: string | undefined;
    /** 计量单位 */
    materialUnit: string | undefined;
    /** 备注 */
    remark: string | undefined;
    /** 移库数量 */
    shiftNum: number | undefined;
    /** 源库存数量 */
    stockNum: number | undefined;
    /** 目标库区id */
    toAreaId: string | undefined;
    /** 目标库区名称 */
    toAreaName: string | undefined;
    /** 目标库位id */
    toLocationId: string | undefined;
    /** 目标库位名称 */
    toLocationName: string | undefined;
}

/** 移库单物料 */
export class StockShiftOrderMaterialVO implements IStockShiftOrderMaterialVO {
    /** 自定义字段1 */
    extend1!: string | undefined;
    /** 自定义字段2 */
    extend2!: string | undefined;
    /** 自定义字段3 */
    extend3!: string | undefined;
    /** 自定义字段4 */
    extend4!: string | undefined;
    /** 自定义字段5 */
    extend5!: string | undefined;
    /** 源库区 */
    fromAreaName!: string | undefined;
    /** 源库位 */
    fromLocationName!: string | undefined;
    /** id */
    id!: string | undefined;
    /** 物料编码 */
    materialCode!: string | undefined;
    /** 所属物料id */
    materialId!: string | undefined;
    /** 物料名称 */
    materialName!: string | undefined;
    materialStuff!: string | undefined;
    /** 物料类型 */
    materialType!: string | undefined;
    /** 所属移库单id */
    orderId!: string | undefined;
    /** 移库说明 */
    remark!: string | undefined;
    /** 移库数量 */
    shiftNum!: number | undefined;
    /** 规格型号 */
    standardModel!: string | undefined;
    /** 目标库区 */
    toAreaName!: string | undefined;
    /** 目标库位 */
    toLocationName!: string | undefined;
    /** 计量单位 */
    unit!: string | undefined;

    constructor(data?: IStockShiftOrderMaterialVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extend1 = data["extend1"];
            this.extend2 = data["extend2"];
            this.extend3 = data["extend3"];
            this.extend4 = data["extend4"];
            this.extend5 = data["extend5"];
            this.fromAreaName = data["fromAreaName"];
            this.fromLocationName = data["fromLocationName"];
            this.id = data["id"];
            this.materialCode = data["materialCode"];
            this.materialId = data["materialId"];
            this.materialName = data["materialName"];
            this.materialStuff = data["materialStuff"];
            this.materialType = data["materialType"];
            this.orderId = data["orderId"];
            this.remark = data["remark"];
            this.shiftNum = data["shiftNum"];
            this.standardModel = data["standardModel"];
            this.toAreaName = data["toAreaName"];
            this.toLocationName = data["toLocationName"];
            this.unit = data["unit"];
        }
    }

    static fromJS(data: any): StockShiftOrderMaterialVO {
        data = typeof data === 'object' ? data : {};
        let result = new StockShiftOrderMaterialVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extend1"] = this.extend1;
        data["extend2"] = this.extend2;
        data["extend3"] = this.extend3;
        data["extend4"] = this.extend4;
        data["extend5"] = this.extend5;
        data["fromAreaName"] = this.fromAreaName;
        data["fromLocationName"] = this.fromLocationName;
        data["id"] = this.id;
        data["materialCode"] = this.materialCode;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialStuff"] = this.materialStuff;
        data["materialType"] = this.materialType;
        data["orderId"] = this.orderId;
        data["remark"] = this.remark;
        data["shiftNum"] = this.shiftNum;
        data["standardModel"] = this.standardModel;
        data["toAreaName"] = this.toAreaName;
        data["toLocationName"] = this.toLocationName;
        data["unit"] = this.unit;
        return data; 
    }
}

/** 移库单物料 */
export interface IStockShiftOrderMaterialVO {
    /** 自定义字段1 */
    extend1: string | undefined;
    /** 自定义字段2 */
    extend2: string | undefined;
    /** 自定义字段3 */
    extend3: string | undefined;
    /** 自定义字段4 */
    extend4: string | undefined;
    /** 自定义字段5 */
    extend5: string | undefined;
    /** 源库区 */
    fromAreaName: string | undefined;
    /** 源库位 */
    fromLocationName: string | undefined;
    /** id */
    id: string | undefined;
    /** 物料编码 */
    materialCode: string | undefined;
    /** 所属物料id */
    materialId: string | undefined;
    /** 物料名称 */
    materialName: string | undefined;
    materialStuff: string | undefined;
    /** 物料类型 */
    materialType: string | undefined;
    /** 所属移库单id */
    orderId: string | undefined;
    /** 移库说明 */
    remark: string | undefined;
    /** 移库数量 */
    shiftNum: number | undefined;
    /** 规格型号 */
    standardModel: string | undefined;
    /** 目标库区 */
    toAreaName: string | undefined;
    /** 目标库位 */
    toLocationName: string | undefined;
    /** 计量单位 */
    unit: string | undefined;
}

/** 新建移库单 */
export class StockShiftOrderSubmitDTO implements IStockShiftOrderSubmitDTO {
    /** 规则id */
    codeRuleId!: string | undefined;
    /** 移库单物料集合 */
    list!: StockShiftOrderMaterialDTO[] | undefined;
    /** 移库单编号 */
    orderCode!: string | undefined;
    /** 移库单名称 */
    orderName!: string | undefined;
    /** 移库部门 */
    shiftDept!: string | undefined;
    /** 移库部门名称 */
    shiftDeptName!: string | undefined;
    /** 移库时间 */
    shiftTime!: Date | undefined;
    /** 移库人员 */
    shiftUser!: string | undefined;
    /** 移库人员名称 */
    shiftUserName!: string | undefined;
    /** 入库类型 */
    stockInTypeId!: string | undefined;
    /** 入库类型名称 */
    stockInTypeName!: string | undefined;
    /** 出库类型 */
    stockOutTypeId!: string | undefined;
    /** 出库类型名称 */
    stockOutTypeName!: string | undefined;

    constructor(data?: IStockShiftOrderSubmitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.codeRuleId = data["codeRuleId"];
            if (data["list"] && data["list"].constructor === Array) {
                this.list = [] as any;
                for (let item of data["list"])
                    this.list!.push(StockShiftOrderMaterialDTO.fromJS(item));
            }
            this.orderCode = data["orderCode"];
            this.orderName = data["orderName"];
            this.shiftDept = data["shiftDept"];
            this.shiftDeptName = data["shiftDeptName"];
            this.shiftTime = data["shiftTime"] ? new Date(data["shiftTime"].toString()) : <any>undefined;
            this.shiftUser = data["shiftUser"];
            this.shiftUserName = data["shiftUserName"];
            this.stockInTypeId = data["stockInTypeId"];
            this.stockInTypeName = data["stockInTypeName"];
            this.stockOutTypeId = data["stockOutTypeId"];
            this.stockOutTypeName = data["stockOutTypeName"];
        }
    }

    static fromJS(data: any): StockShiftOrderSubmitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StockShiftOrderSubmitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeRuleId"] = this.codeRuleId;
        if (this.list && this.list.constructor === Array) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        data["orderCode"] = this.orderCode;
        data["orderName"] = this.orderName;
        data["shiftDept"] = this.shiftDept;
        data["shiftDeptName"] = this.shiftDeptName;
        data["shiftTime"] = this.shiftTime ? this.shiftTime.toISOString() : <any>undefined;
        data["shiftUser"] = this.shiftUser;
        data["shiftUserName"] = this.shiftUserName;
        data["stockInTypeId"] = this.stockInTypeId;
        data["stockInTypeName"] = this.stockInTypeName;
        data["stockOutTypeId"] = this.stockOutTypeId;
        data["stockOutTypeName"] = this.stockOutTypeName;
        return data; 
    }
}

/** 新建移库单 */
export interface IStockShiftOrderSubmitDTO {
    /** 规则id */
    codeRuleId: string | undefined;
    /** 移库单物料集合 */
    list: StockShiftOrderMaterialDTO[] | undefined;
    /** 移库单编号 */
    orderCode: string | undefined;
    /** 移库单名称 */
    orderName: string | undefined;
    /** 移库部门 */
    shiftDept: string | undefined;
    /** 移库部门名称 */
    shiftDeptName: string | undefined;
    /** 移库时间 */
    shiftTime: Date | undefined;
    /** 移库人员 */
    shiftUser: string | undefined;
    /** 移库人员名称 */
    shiftUserName: string | undefined;
    /** 入库类型 */
    stockInTypeId: string | undefined;
    /** 入库类型名称 */
    stockInTypeName: string | undefined;
    /** 出库类型 */
    stockOutTypeId: string | undefined;
    /** 出库类型名称 */
    stockOutTypeName: string | undefined;
}

/** 移库单分页信息 */
export class StockShiftOrderVO implements IStockShiftOrderVO {
    /** id */
    id!: string | undefined;
    /** 移库单编号 */
    orderCode!: string | undefined;
    /** 移库单名称 */
    orderName!: string | undefined;
    /** 移库部门 */
    shiftDept!: string | undefined;
    /** 移库时间 */
    shiftTime!: Date | undefined;
    /** 移库人员 */
    shiftUser!: string | undefined;
    /** 入库类型 */
    stockInTypeId!: string | undefined;
    /** 入库类型 */
    stockInTypeName!: string | undefined;
    /** 出库类型 */
    stockOutTypeId!: string | undefined;
    /** 出库类型 */
    stockOutTypeName!: string | undefined;

    constructor(data?: IStockShiftOrderVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.orderCode = data["orderCode"];
            this.orderName = data["orderName"];
            this.shiftDept = data["shiftDept"];
            this.shiftTime = data["shiftTime"] ? new Date(data["shiftTime"].toString()) : <any>undefined;
            this.shiftUser = data["shiftUser"];
            this.stockInTypeId = data["stockInTypeId"];
            this.stockInTypeName = data["stockInTypeName"];
            this.stockOutTypeId = data["stockOutTypeId"];
            this.stockOutTypeName = data["stockOutTypeName"];
        }
    }

    static fromJS(data: any): StockShiftOrderVO {
        data = typeof data === 'object' ? data : {};
        let result = new StockShiftOrderVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderCode"] = this.orderCode;
        data["orderName"] = this.orderName;
        data["shiftDept"] = this.shiftDept;
        data["shiftTime"] = this.shiftTime ? this.shiftTime.toISOString() : <any>undefined;
        data["shiftUser"] = this.shiftUser;
        data["stockInTypeId"] = this.stockInTypeId;
        data["stockInTypeName"] = this.stockInTypeName;
        data["stockOutTypeId"] = this.stockOutTypeId;
        data["stockOutTypeName"] = this.stockOutTypeName;
        return data; 
    }
}

/** 移库单分页信息 */
export interface IStockShiftOrderVO {
    /** id */
    id: string | undefined;
    /** 移库单编号 */
    orderCode: string | undefined;
    /** 移库单名称 */
    orderName: string | undefined;
    /** 移库部门 */
    shiftDept: string | undefined;
    /** 移库时间 */
    shiftTime: Date | undefined;
    /** 移库人员 */
    shiftUser: string | undefined;
    /** 入库类型 */
    stockInTypeId: string | undefined;
    /** 入库类型 */
    stockInTypeName: string | undefined;
    /** 出库类型 */
    stockOutTypeId: string | undefined;
    /** 出库类型 */
    stockOutTypeName: string | undefined;
}

export class TestMaterialDTO implements ITestMaterialDTO {
    /** 文件mini类型 */
    contentType!: string | undefined;
    /** 检测文件名 */
    fileName!: string | undefined;
    /** 文件key */
    fileObjectKey!: string | undefined;
    /** 入库单下物料Id */
    id!: string | undefined;
    /** 模式（1：保存；2：保存入库） */
    model!: number;
    /** 检验结果：0-失败，1-成功 */
    testResult!: number | undefined;

    constructor(data?: ITestMaterialDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.fileName = data["fileName"];
            this.fileObjectKey = data["fileObjectKey"];
            this.id = data["id"];
            this.model = data["model"];
            this.testResult = data["testResult"];
        }
    }

    static fromJS(data: any): TestMaterialDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TestMaterialDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["fileName"] = this.fileName;
        data["fileObjectKey"] = this.fileObjectKey;
        data["id"] = this.id;
        data["model"] = this.model;
        data["testResult"] = this.testResult;
        return data; 
    }
}

export interface ITestMaterialDTO {
    /** 文件mini类型 */
    contentType: string | undefined;
    /** 检测文件名 */
    fileName: string | undefined;
    /** 文件key */
    fileObjectKey: string | undefined;
    /** 入库单下物料Id */
    id: string | undefined;
    /** 模式（1：保存；2：保存入库） */
    model: number;
    /** 检验结果：0-失败，1-成功 */
    testResult: number | undefined;
}

/** 批量是否入库 */
export class WarehousingDTO implements IWarehousingDTO {
    /** id */
    ids!: string[] | undefined;
    /** [是：1/否：0] */
    isOrNot!: number | undefined;

    constructor(data?: IWarehousingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [] as any;
                for (let item of data["ids"])
                    this.ids!.push(item);
            }
            this.isOrNot = data["isOrNot"];
        }
    }

    static fromJS(data: any): WarehousingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WarehousingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["isOrNot"] = this.isOrNot;
        return data; 
    }
}

/** 批量是否入库 */
export interface IWarehousingDTO {
    /** id */
    ids: string[] | undefined;
    /** [是：1/否：0] */
    isOrNot: number | undefined;
}